var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, EventHandler, Complex, Browser, addClass, detach, updateCSSText, isNullOrUndefined } from '@syncfusion/ej2-base';
import { Property, NotifyPropertyChanges, formatUnit, L10n, closest } from '@syncfusion/ej2-base';
import { setStyleAttribute, Event, removeClass, print as printWindow, attributes } from '@syncfusion/ej2-base';
import { isNullOrUndefined as isNOU, compile, append, extend, debounce } from '@syncfusion/ej2-base';
import { Touch as EJ2Touch, initializeTelemetry } from '@syncfusion/ej2-base';
import { getScrollableParent } from '@syncfusion/ej2-popups';
import * as events from '../base/constant';
import { getWebMcpTools, registerWebMcpTools } from '../base/constant';
import * as EVENTS from './../../common/constant';
import * as classes from '../base/classes';
import { Render } from '../renderer/render';
import { ViewSource } from '../renderer/view-source';
import { executeGroup } from './interface';
import { ServiceLocator } from '../services/service-locator';
import { RendererFactory } from '../services/renderer-factory';
import { RenderType } from './enum';
import { ExecCommandCallBack } from '../actions/execute-command-callback';
import { KeyboardEvents } from '../actions/keyboard';
import { ToolbarSettings, ImageSettings, AudioSettings, VideoSettings, QuickToolbarSettings, FontFamily, FontSize, Format, NumberFormatList, BulletFormatList, FormatPainterSettings, ImportWord, ExportWord, ExportPdf, CodeBlockSettings, LineHeight } from '../../models/toolbar-settings';
import { EmojiSettings } from '../../models/emoji-settings';
import { FileManagerSettings } from '../models/fileManager-settings';
import { TableSettings, PasteCleanupSettings } from '../../models/toolbar-settings';
import { FontColor, BackgroundColor } from '../../models/toolbar-settings';
import { IFrameSettings } from '../../models/iframe-settings';
import { InlineMode } from '../../models/inline-mode';
import { defaultLocale } from '../models/default-locale';
import { setAttributes } from '../actions/html-attributes';
import { FullScreen } from '../actions/full-screen';
import * as CONSTANT from '../../common/constant';
import { dispatchEvent, getEditValue, decode, isEditableValueEmpty, getDefaultValue } from '../base/util';
import { cleanHTMLString, scrollToCursor, getStructuredHtml, isIDevice, alignmentHtml, openPrintWindow } from '../../common/util';
import { DialogRenderer } from '../renderer/dialog-renderer';
import { SlashMenuSettings } from '../../models/slash-menu-settings';
import { mentionRestrictKeys } from '../../common/config';
import { CustomUserAgentData } from '../../common/user-agent';
import { cleanupInternalElements, removeSelectionClassStates, resetContentEditableElements } from '../../common/util';
import { NodeSelection } from '../../selection/index';
import { DialogType } from '../../common/enum';
import { AIAssistantSettings } from '../models/ai-assistant-settings';
import { DEFAULT_AI_COMMANDS } from '../models/items';
import { PopupUploader } from '../renderer/popup-uploader-renderer';
import { sanitizeHelper } from '../base/util';
import { ToolbarStatus } from '../../editor-manager/plugin/toolbar-status';
import { RichTextEditorWebMcpSettings } from '../models/webmcp-settings';
/**
 * Represents the Rich Text Editor component.
 * ```html
 * <textarea id="rte"></textarea>
 * <script>
 *  var rteObj = new RichTextEditor();
 *  rteObj.appendTo("#rte");
 * </script>
 * ```
 */
var RichTextEditor = /** @class */ (function (_super) {
    __extends(RichTextEditor, _super);
    function RichTextEditor(options, element) {
        var _this = _super.call(this, options, element) || this;
        _this.hasContentChanged = false;
        _this.isModalDialog = false;
        _this.isPlainPaste = false;
        _this.needsID = true;
        _this.isCopyAll = false;
        _this.isSelecting = false;
        _this.isSelectionStartInRTE = false;
        _this.isRTEFocused = false;
        _this.isFullTableDeleted = false;
        _this.isLastCharInline = false;
        return _this;
    }
    /**
     * Returns the WebMCP tool schemas for the given tool names.
     * When `toolNames` is omitted, schemas for all available tools are returned.
     *
     * @param {string[]} toolNames - Optional: filter tool names. Omit to get all tools.
     * @returns {WebMcpTool[]} - Array of tool schema objects matching the specified names
     */
    RichTextEditor.prototype.getWebMcpTools = function (toolNames) {
        var args = { toolNames: toolNames };
        this.notify(getWebMcpTools, args);
        return args.tools || [];
    };
    /**
     * To provide the array of modules needed for component rendering
     *
     * @returns {ModuleDeclaration[]} - specifies the declaration.
     * @hidden
     * @deprecated
     */
    RichTextEditor.prototype.requiredModules = function () {
        var modules = [];
        if (this.toolbarSettings.enable) {
            modules.push({ member: 'toolbar', args: [this, this.serviceLocator] });
            if (this.quickToolbarSettings.enable) {
                modules.push({ member: 'quickToolbar', args: [this, this.serviceLocator] });
            }
        }
        if (this.editorMode === 'HTML' && this.slashMenuSettings.enable) {
            modules.push({ member: 'slashMenu', args: [this, this.serviceLocator] });
        }
        if (this.showCharCount) {
            modules.push({ member: 'count', args: [this, this.serviceLocator] });
        }
        if (this.editorMode === 'Markdown') {
            modules.push({ member: 'markdownEditor', args: [this, this.serviceLocator] });
        }
        modules.push({
            member: 'link',
            args: [this, this.serviceLocator]
        });
        modules.push({
            member: 'table',
            args: [this, this.serviceLocator]
        });
        modules.push({
            member: 'image',
            args: [this, this.serviceLocator]
        });
        if (this.editorMode === 'HTML') {
            modules.push({
                member: 'audio',
                args: [this, this.serviceLocator]
            });
            modules.push({
                member: 'video',
                args: [this, this.serviceLocator]
            });
            modules.push({ member: 'htmlEditor', args: [this, this.serviceLocator] });
            modules.push({ member: 'pasteCleanup', args: [this, this.serviceLocator] });
            modules.push({ member: 'importExport', args: [this, this.serviceLocator] });
            modules.push({
                member: 'formatPainter',
                args: [this]
            });
            modules.push({
                member: 'emojiPicker',
                args: [this, this.serviceLocator]
            });
            modules.push({
                member: 'codeBlock',
                args: [this, this.serviceLocator]
            });
            if (this.enableClipboardCleanup) {
                modules.push({ member: 'clipBoardCleanup', args: [this] });
            }
            if (this.enableMarkdownAutoFormat) {
                modules.push({
                    member: 'autoFormat',
                    args: [this]
                });
            }
            modules.push({
                member: 'aiAssistant',
                args: [this, this.serviceLocator]
            });
        }
        if (this.fileManagerSettings.enable) {
            modules.push({ member: 'fileManager', args: [this, this.serviceLocator] });
        }
        if (this.enableResize) {
            modules.push({ member: 'resize', args: [this] });
        }
        if (this.enableWebMcp) {
            modules.push({ member: 'WebMcpRichTextEditor', args: [this] });
        }
        return modules;
    };
    RichTextEditor.prototype.updateEnable = function () {
        if (this.enabled) {
            removeClass([this.element], classes.CLS_DISABLED);
            this.element.setAttribute('aria-disabled', 'false');
            if (!isNOU(this.htmlAttributes.tabindex)) {
                this.inputElement.setAttribute('tabindex', this.htmlAttributes.tabindex);
            }
            else {
                this.inputElement.setAttribute('tabindex', '0');
            }
        }
        else {
            if (this.getToolbar()) {
                removeClass(this.getToolbar().querySelectorAll('.' + classes.CLS_ACTIVE), classes.CLS_ACTIVE);
                removeClass([this.getToolbar().parentElement], [classes.CLS_TB_FLOAT]);
            }
            addClass([this.element], classes.CLS_DISABLED);
            this.element.tabIndex = -1;
            this.element.setAttribute('aria-disabled', 'true');
            this.inputElement.setAttribute('tabindex', '-1');
        }
    };
    /**
     * setEnable method
     *
     * @returns {void}
     * @hidden
     * @deprecated
     */
    RichTextEditor.prototype.setEnable = function () {
        this.updateEnable();
        // eslint-disable-next-line
        (this.enabled) ? this.eventInitializer() : this.unWireEvents();
    };
    RichTextEditor.prototype.initializeValue = function () {
        this.isFocusOut = false;
        this.isRTE = false;
        this.isToolbarClipboardAction = false;
        this.isBlur = true;
        this.defaultResetValue = null;
        this.isResizeInitialized = false;
    };
    /**
     * For internal use only - Initialize the event handler;
     *
     * @returns {void}
     * @hidden
     * @private
     */
    RichTextEditor.prototype.preRender = function () {
        this.initializeValue();
        this.clickPoints = { clientX: 0, clientY: 0 };
        this.initialValue = this.value;
        this.serviceLocator = new ServiceLocator;
        this.initializeServices();
        this.setContainer();
        this.persistData();
        setStyleAttribute(this.element, { 'width': formatUnit(this.width) });
        attributes(this.element, { role: 'application', 'aria-label': 'Rich Text Editor' });
        this.beforeRenderClassValue = this.element.getAttribute('class');
    };
    RichTextEditor.prototype.persistData = function () {
        if (this.enablePersistence && this.originalElement.tagName === 'TEXTAREA') {
            this.element.id = this.originalElement.id + '_wrapper';
            var data = window.localStorage.getItem(this.getModuleName() + this.element.id);
            if (!(isNOU(data) || (data === ''))) {
                this.setProperties(JSON.parse(data), true);
            }
        }
    };
    RichTextEditor.prototype.setContainer = function () {
        this.originalElement = this.element.cloneNode(true);
        if (this.value === null || this.valueTemplate !== null) {
            this.setValue();
        }
        if (this.element.hasAttribute('tabindex')) {
            this.htmlAttributes = { 'tabindex': this.element.getAttribute('tabindex') };
            this.element.removeAttribute('tabindex');
        }
        this.element.innerHTML = '';
        var invalidAttr = ['class', 'style', 'id', 'ejs-for'];
        var htmlAttr = {};
        for (var a = 0; a < this.element.attributes.length; a++) {
            if (invalidAttr.indexOf(this.element.attributes[a].name) === -1 &&
                !(/^data-val/.test(this.element.attributes[a].name))) { // data-val for asp.net core data annotation validation.
                htmlAttr[this.element.attributes[a].name] = this.element.getAttribute(this.element.attributes[a].name);
            }
        }
        extend(htmlAttr, this.htmlAttributes, htmlAttr);
        this.setProperties({ htmlAttributes: htmlAttr }, true);
        if (!isNOU(this.htmlAttributes.id)) {
            this.element.id = this.htmlAttributes.id;
        }
        this.internalID = this.element.id;
        if (this.element.tagName === 'TEXTAREA') {
            var rteOuterWrapper = this.createElement('div', {
                className: this.element.getAttribute('class')
            });
            this.element.innerHTML = '';
            this.element.parentElement.insertBefore(rteOuterWrapper, this.element);
            this.valueContainer = this.element;
            removeClass([this.valueContainer], this.element.getAttribute('class').split(' '));
            this.element = rteOuterWrapper;
        }
        else {
            this.valueContainer = this.createElement('textarea', {
                id: this.getID() + '-value',
                attrs: { 'aria-labelledby': this.getID() }
            });
        }
        this.valueContainer.name = this.getID();
        addClass([this.valueContainer], classes.CLS_RTE_HIDDEN);
        if (!isNOU(this.cssClass)) {
            var currentClassList = this.cssClass.split(' ');
            for (var i = 0; i < currentClassList.length; i++) {
                addClass([this.valueContainer], currentClassList[i]);
            }
        }
        this.rootContainer = this.createElement('div', { className: classes.CLS_RTE_CONTAINER, attrs: { 'role': 'presentation' } });
        this.element.appendChild(this.rootContainer);
        this.rootContainer.appendChild(this.valueContainer);
    };
    /**
     * getPersistData method
     *
     * @returns {void}
     * @hidden
     * @deprecated
     */
    RichTextEditor.prototype.getPersistData = function () {
        return this.addOnPersist(['value']);
    };
    /**
     * Focuses the Rich Text Editor component.
     *
     * @returns {void}
     * @public
     */
    RichTextEditor.prototype.focusIn = function () {
        if (this.enabled) {
            this.inputElement.focus();
            this.focusHandler({});
            this.notify(events.toolbarRefresh, {});
        }
    };
    /**
     * Blurs the Rich Text Editor component, removing focus.
     *
     * @returns {void}
     * @public
     */
    RichTextEditor.prototype.focusOut = function () {
        if (this.enabled) {
            this.inputElement.blur();
            this.blurHandler({});
        }
    };
    /**
     * Selects all content within the RichTextEditor.
     *
     * @returns {void}
     * @public
     */
    RichTextEditor.prototype.selectAll = function () {
        this.notify(events.selectAll, {});
    };
    /**
     * Selects a specific content range or element.
     *
     * @param {Range} range - Specify the range you want to select within the content.
     * This method is used to select a particular sentence, word, or the entire document.
     *
     * @returns {void}
     * @public
     */
    RichTextEditor.prototype.selectRange = function (range) {
        this.notify(events.selectRange, { range: range });
    };
    /**
     * Retrieves the HTML markup from the currently selected content in RichTextEditor.
     *
     * @returns {string} - Returns the HTML string of selected content.
     * @public
     */
    RichTextEditor.prototype.getSelection = function () {
        var str = '';
        this.notify(events.getSelectedHtml, {
            callBack: function (txt) {
                str = txt;
            }
        });
        return str;
    };
    /**
     * Displays the emoji picker. If coordinates are provided, it positions the picker at those locations.
     *
     * @param {number} x - The x-axis position for the emoji picker.
     * @param {number} y - The y-axis position for the emoji picker.
     * @returns {void}
     * @public
     */
    RichTextEditor.prototype.showEmojiPicker = function (x, y) {
        if (this.readonly) {
            return;
        }
        this.notify(events.emojiPicker, { x: x, y: y });
    };
    /**
     * Executes a specified command within the rich text editor, optionally utilizing additional parameters to tailor execution.
     *
     * @returns {void}
     * @param {CommandName} commandName - The name of the command to be executed, such as 'importWord', 'insertHTML', and others.
     * @param {string | HTMLElement | ILinkCommandsArgs | IImageCommandsArgs | ITableCommandsArgs | FormatPainterSettingsModel | IAudioCommandsArgs | IVideoCommandsArgs} value
     * - An optional parameter that supplies the necessary value relevant to the command. This could be a string, an HTMLElement, or specific argument types like ILinkCommandsArgs, etc., contingent on the command requirements.
     * @param {ExecuteCommandOption} option - Specifies additional options for executing the command, such as enabling features like undo functionality.
     * @public
     */
    RichTextEditor.prototype.executeCommand = function (commandName, value, option) {
        if (commandName === 'importWord') {
            var importContainer = this.createElement('div');
            importContainer.innerHTML = value;
            var tableElement = importContainer.querySelectorAll('table:not(.e-rte-table):not(.e-rte-paste-table)');
            for (var i = 0; i < tableElement.length; i++) {
                tableElement[i].classList.add('e-rte-paste-table');
            }
            value = importContainer.innerHTML;
            importContainer.remove();
            commandName = 'insertHTML';
        }
        value = this.htmlPurifier(commandName, value);
        var internalValue;
        if (this.editorMode === 'HTML') {
            var range = this.getRange();
            if (this.iframeSettings.enable) {
                this.formatter.editorManager.nodeSelection.Clear(this.element.ownerDocument);
            }
            var toFocus = (this.iframeSettings.enable &&
                range.startContainer === this.inputElement) ? true : !this.inputElement.contains(range.startContainer);
            if (this.iframeSettings.enable) {
                toFocus = true;
            }
            if (toFocus) {
                this.focusIn();
            }
        }
        var tool = executeGroup["" + commandName];
        if (option && option.undo) {
            if (option.undo && this.formatter.getUndoRedoStack().length === 0) {
                this.formatter.saveData();
            }
        }
        if (this.maxLength !== -1 && !isNOU(tool.command)) {
            var currentInsertContentLength = 0;
            if (tool.command === 'Links') {
                currentInsertContentLength = value.text.length === 0 ?
                    value.url.length : value.text.length;
            }
            if (tool.command === 'Images' || tool.command === 'Table' || tool.command === 'Files') {
                currentInsertContentLength = 1;
            }
            if (tool.command === 'InsertHTML') {
                if (!isNOU(value)) {
                    var tempElem = this.createElement('div');
                    tempElem.innerHTML = value;
                    currentInsertContentLength = tempElem.textContent.length;
                }
                else if (!isNOU(tool.value) && (tool.value === '<hr/>' || tool.value === '<br/>')) {
                    currentInsertContentLength = 1;
                }
            }
            if (tool.command === 'InsertText') {
                currentInsertContentLength = value.length;
            }
            var currentLength = this.getText().trim().replace(/(\r\n|\n|\r|\t)/gm, '').replace(/\u200B/g, '').length;
            var selectionLength = this.getSelection().length;
            var totalLength = (currentLength - selectionLength) + currentInsertContentLength;
            if (!(this.maxLength === -1 || totalLength <= this.maxLength)) {
                return;
            }
        }
        internalValue = value;
        if (tool.command === 'FormatPainter') {
            if (!isNOU(value)) {
                this.formatPainterSettings = value;
            }
            internalValue = {
                formatPainterAction: tool.value
            };
        }
        if (tool.command === 'lineHeight') {
            internalValue = { selectedValue: (value ? value : tool.value) };
        }
        if (tool.command === 'CodeBlock' && !isNOU(value)) {
            value.action = 'createCodeBlock';
        }
        if ((tool.subCommand === 'NumberFormatList' || tool.subCommand === 'BulletFormatList')) {
            internalValue = { listStyle: value, type: tool.subCommand };
        }
        this.formatter.editorManager.execCommand(tool.command, tool.subCommand ? tool.subCommand : (internalValue ? internalValue : tool.value), null, null, (internalValue ? internalValue : tool.value), (internalValue ? internalValue : (tool.value === 'UL' || tool.value === 'OL') ? null : tool.value), null, this.enterKey);
        scrollToCursor(this.contentModule.getDocument(), this.inputElement);
        if (option && option.undo) {
            this.formatter.saveData();
            this.formatter.enableUndo(this);
        }
        this.setPlaceHolder();
        this.notify(events.contentChanged, {});
    };
    RichTextEditor.prototype.htmlPurifier = function (command, value) {
        if (this.editorMode === 'HTML') {
            switch (command) {
                case 'insertHTML':
                    if (this.enableHtmlSanitizer) {
                        if (typeof value === 'string') {
                            value = value.replace(/&(times|divide|ne)/g, '&amp;amp;$1');
                            value = this.htmlEditorModule.sanitizeHelper(value);
                        }
                        else {
                            value = this.htmlEditorModule.sanitizeHelper(value.outerHTML);
                        }
                    }
                    break;
                case 'insertTable':
                    if (isNOU(value.width)) {
                        value.width = {
                            minWidth: this.tableSettings.minWidth,
                            maxWidth: this.tableSettings.maxWidth, width: this.tableSettings.width
                        };
                    }
                    break;
                case 'insertImage': {
                    var temp = this.createElement('img', {
                        attrs: {
                            src: value.url
                        }
                    });
                    var imageValue = temp.outerHTML;
                    if (this.enableHtmlSanitizer) {
                        imageValue = this.htmlEditorModule.sanitizeHelper(temp.outerHTML);
                    }
                    var url = (imageValue !== '' && (this.createElement('div', {
                        innerHTML: imageValue
                    }).firstElementChild).getAttribute('src')) || null;
                    url = !isNOU(url) ? url : '';
                    value.url = url;
                    if (isNOU(value.width)) {
                        value.width = {
                            minWidth: this.insertImageSettings.minWidth,
                            maxWidth: this.insertImageSettings.maxWidth, width: this.insertImageSettings.width
                        };
                    }
                    if (isNOU(value.height)) {
                        value.height = {
                            minHeight: this.insertImageSettings.minHeight,
                            maxHeight: this.insertImageSettings.maxHeight, height: this.insertImageSettings.height
                        };
                    }
                    break;
                }
                case 'insertAudio': {
                    var wrapTemp = this.createElement('audio', {
                        attrs: {
                            controls: ''
                        }
                    });
                    var temp = this.createElement('source', {
                        attrs: {
                            src: value.url,
                            type: value.url && value.url.split('.').length > 0
                                ? 'audio/' + value.url.split('.')[value.url.split('.').length - 1] : ''
                        }
                    });
                    wrapTemp.appendChild(temp);
                    var audioValue = wrapTemp.outerHTML;
                    if (this.enableHtmlSanitizer) {
                        audioValue = this.htmlEditorModule.sanitizeHelper(wrapTemp.outerHTML);
                    }
                    var url = (audioValue !== '' && (this.createElement('div', {
                        innerHTML: audioValue
                    }).firstElementChild.firstElementChild).getAttribute('src')) || null;
                    url = !isNOU(url) ? url : '';
                    value.url = url;
                    break;
                }
                case 'insertVideo': {
                    var wrapTemp = this.createElement('video', {
                        attrs: {
                            controls: ''
                        }
                    });
                    var temp = this.createElement('source', {
                        attrs: {
                            src: value.url,
                            type: value.url && value.url.split('.').length > 0
                                ? 'video/' + value.url.split('.')[value.url.split('.').length - 1] : ''
                        }
                    });
                    wrapTemp.appendChild(temp);
                    var audioValue = wrapTemp.outerHTML;
                    if (this.enableHtmlSanitizer) {
                        audioValue = this.htmlEditorModule.sanitizeHelper(temp.outerHTML);
                    }
                    var url = (audioValue !== '' && (this.createElement('div', {
                        innerHTML: audioValue
                    }).firstElementChild).getAttribute('src')) || null;
                    url = !isNOU(url) ? url : '';
                    value.url = url;
                    if (isNOU(value.width)) {
                        value.width = {
                            minWidth: this.insertVideoSettings.minWidth,
                            maxWidth: this.insertVideoSettings.maxWidth, width: this.insertVideoSettings.width
                        };
                    }
                    if (isNOU(value.height)) {
                        value.height = {
                            minHeight: this.insertVideoSettings.minHeight,
                            maxHeight: this.insertVideoSettings.maxHeight, height: this.insertVideoSettings.height
                        };
                    }
                    break;
                }
                case 'createLink': {
                    var tempNode = this.createElement('a', {
                        attrs: {
                            href: value.url
                        }
                    });
                    var linkValue = tempNode.outerHTML;
                    if (this.enableHtmlSanitizer) {
                        linkValue = this.htmlEditorModule.sanitizeHelper(tempNode.outerHTML);
                    }
                    var href = (linkValue !== '' && (this.createElement('div', {
                        innerHTML: linkValue
                    }).firstElementChild).getAttribute('href')) || null;
                    href = !isNOU(href) ? href : '';
                    value.url = href;
                    break;
                }
            }
        }
        return value;
    };
    RichTextEditor.prototype.isMediaUploading = function () {
        // To prevent any editor content changes while uploading is happening
        if (isNOU(this.element)) {
            return false;
        }
        var mediaPopups = this.element.querySelectorAll('.e-rte-upload-popup');
        if (mediaPopups.length > 0) {
            return true;
        }
        return false;
    };
    RichTextEditor.prototype.encode = function (value) {
        var divNode = this.createElement('div');
        divNode.innerText = value.trim();
        // eslint-disable-next-line
        return divNode.innerHTML.replace(/<br\s*[\/]?>/gi, '\n');
    };
    RichTextEditor.prototype.toolbarStatusUpdateOnLoad = function () {
        if (this.editorMode !== 'HTML') {
            return;
        }
        var fontsize = [];
        var fontName = [];
        var formats = [];
        this.fontSize.items.forEach(function (item) {
            fontsize.push(item.value);
        });
        this.fontFamily.items.forEach(function (item) {
            fontName.push(item.value);
        });
        this.format.types.forEach(function (item) {
            formats.push(item.value.toLocaleLowerCase());
        });
        var firstTextNode = this.formatter.editorManager.domTree.getFirstTextNode(this.contentModule.getEditPanel());
        if (isNOU(firstTextNode)) {
            return;
        }
        var toolbarStatus = ToolbarStatus.get(this.contentModule.getDocument(), this.contentModule.getEditPanel(), formats, fontsize, fontName, firstTextNode);
        var tbStatusString = JSON.stringify(toolbarStatus);
        this.notify(events.toolbarUpdated, toolbarStatus);
    };
    /**
     * For internal use only - To Initialize the component rendering.
     *
     * @returns {void}
     * @private
     * @deprecated
     */
    RichTextEditor.prototype.render = function () {
        initializeTelemetry('RichTextEditor');
        this.setProperties({ value: this.replaceEntities(this.value) }, true);
        if (this.value && !this.valueTemplate) {
            this.setProperties({ value: this.serializeValue(this.value) }, true);
        }
        this.value = (!(this.editorMode === 'Markdown') && !isNOU(this.value)) ? this.addAnchorAriaLabel(this.value) : this.value;
        this.renderModule = new Render(this, this.serviceLocator);
        this.sourceCodeModule = new ViewSource(this, this.serviceLocator);
        this.notify(events.initialLoad, {});
        this.trigger(events.load);
        this.RTERender();
        // eslint-disable-next-line
        var execCommandCallBack = new ExecCommandCallBack(this);
        if (this.element.dataset.rteUnitTesting === 'true') {
            this.userAgentData = new CustomUserAgentData(Browser.userAgent, true);
        }
        else {
            this.userAgentData = new CustomUserAgentData(Browser.userAgent, false);
        }
        this.notify(events.initialEnd, {});
        if (this.enableXhtml) {
            this.value = getStructuredHtml(cleanHTMLString(this.value, this.element), this.enterKey, this.enableHtmlEncode);
            this.setProperties({ value: this.getXhtml() });
        }
        if (this.toolbarSettings.enable && (this.toolbarSettings.type === 'Expand' || this.toolbarSettings.type === 'MultiRow' || this.toolbarSettings.type === 'Scrollable') && !isNOU(this.getToolbar()) &&
            (this.toolbarSettings.items.indexOf('Undo') > -1 && this.toolbarSettings.items.indexOf('Redo') > -1)) {
            this.disableToolbarItem(['Undo', 'Redo']);
        }
        this.updateUIForReadOnlyState(true);
        if (this.value !== null) {
            this.valueContainer.defaultValue = this.value;
        }
        // eslint-disable-next-line
        (this.enabled && !this.readonly) ? this.eventInitializer() : this.unWireEvents();
        this.notify(events.bindCssClass, { cssClass: this.getCssClass() });
        this.addAudioVideoWrapper();
        this.notify(events.tableclass, {});
        this.autoResize();
        this.toolbarStatusUpdateOnLoad();
        this.renderComplete();
        if (this.webMcpSettings && this.webMcpSettings.tools && this.webMcpSettings.tools.length > 0) {
            this.notify(registerWebMcpTools, {
                prefix: this.webMcpSettings.name || this.element.id,
                tools: this.webMcpSettings.tools,
                exposedTo: this.webMcpSettings.exposedTo
            });
        }
    };
    /**
     * addAudioVideoWrapper method
     *
     * @returns {void}
     * @hidden
     * @deprecated
     */
    RichTextEditor.prototype.addAudioVideoWrapper = function () {
        var _this = this;
        var insertElem;
        var audioElm = this.element.querySelectorAll('audio');
        for (var i = 0; i < audioElm.length; i++) {
            if (!audioElm[i].classList.contains('e-rte-audio')) {
                audioElm[i].classList.add('e-rte-audio');
                audioElm[i].classList.add(classes.CLS_AUDIOINLINE);
            }
            // eslint-disable-next-line max-len
            if (!audioElm[i].parentElement.classList.contains(classes.CLS_CLICKELEM) && !audioElm[i].parentElement.classList.contains(classes.CLS_AUDIOWRAP)) {
                var audioWrapElem = this.createElement('span', { className: classes.CLS_AUDIOWRAP });
                var csstext = 'width:300px; margin:0 auto;';
                updateCSSText(audioWrapElem, csstext);
                audioWrapElem.contentEditable = 'false';
                var audioInnerWrapElem = this.createElement('span', { className: classes.CLS_CLICKELEM });
                audioWrapElem.appendChild(audioInnerWrapElem);
                audioElm[i].parentNode.insertBefore(audioWrapElem, audioElm[i].nextSibling);
                audioInnerWrapElem.appendChild(audioElm[i]);
                if (audioWrapElem.nextElementSibling === null) {
                    insertElem = this.createElement('br');
                    audioWrapElem.parentNode.insertBefore(insertElem, audioWrapElem.nextSibling);
                }
            }
        }
        var videoElm = this.element.querySelectorAll('video');
        for (var i = 0; i < videoElm.length; i++) {
            if (!videoElm[i].classList.contains('e-rte-video')) {
                videoElm[i].classList.add('e-rte-video');
                videoElm[i].classList.add(classes.CLS_VIDEOINLINE);
            }
            // eslint-disable-next-line max-len
            if (!videoElm[i].parentElement.classList.contains(classes.CLS_CLICKELEM) && !videoElm[i].parentElement.classList.contains(classes.CLS_VIDEOWRAP)) {
                var videoWrapElem = this.createElement('span', { className: classes.CLS_VIDEOWRAP });
                videoWrapElem.contentEditable = 'false';
                videoElm[i].parentNode.insertBefore(videoWrapElem, videoElm[i].nextSibling);
                videoWrapElem.appendChild(videoElm[i]);
                if (videoWrapElem.nextElementSibling === null) {
                    insertElem = this.createElement('br');
                    videoWrapElem.parentNode.insertBefore(insertElem, videoWrapElem.nextSibling);
                }
            }
            if (Browser.userAgent.indexOf('Firefox') !== -1) {
                // eslint-disable-next-line
                videoElm[i].addEventListener('play', function (args) {
                    _this.notify(events.mouseDown, { args: args });
                    _this.notify('editAreaClick', { args: args });
                });
                // eslint-disable-next-line
                videoElm[i].addEventListener('pause', function (args) {
                    _this.notify(events.mouseDown, { args: args });
                    _this.notify('editAreaClick', { args: args });
                });
            }
        }
    };
    /**
     * For internal use only - Initialize the event handler
     *
     * @returns {void}
     * @private
     * @deprecated
     * @hidden
     */
    RichTextEditor.prototype.eventInitializer = function () {
        this.wireEvents();
    };
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    RichTextEditor.prototype.cleanList = function (e) {
        var range = this.getRange();
        var currentStartContainer = range.startContainer;
        var currentEndContainer = range.endContainer;
        var currentStartOffset = range.startOffset;
        var isSameContainer = currentStartContainer === currentEndContainer ? true : false;
        // eslint-disable-next-line
        var currentEndOffset = currentEndContainer.textContent.length;
        var endNode = range.endContainer.nodeName === '#text' ? range.endContainer.parentElement :
            range.endContainer;
        var closestLI = closest(endNode, 'LI');
        var isDetached = false;
        var currentRangeEndOffset = range.endOffset;
        if (currentEndContainer.nodeType === Node.TEXT_NODE) {
            if (currentEndContainer.textContent.charAt(currentRangeEndOffset - 1) === '\uFEFF') {
                currentRangeEndOffset--;
            }
        }
        if (!isNOU(closestLI) && endNode.textContent.trim().length === currentRangeEndOffset &&
            !range.collapsed && isNOU(endNode.nextElementSibling) && !endNode.classList.contains('e-img-caption-text')) {
            for (var i = 0; i < closestLI.childNodes.length; i++) {
                if (closestLI.childNodes[i].nodeName === '#text' && closestLI.childNodes[i].textContent.trim().length === 0) {
                    detach(closestLI.childNodes[i]);
                    isDetached = true;
                    i--;
                }
            }
            var currentLastElem = closestLI;
            while (currentLastElem.lastChild !== null && currentLastElem.nodeName !== '#text') {
                currentLastElem = currentLastElem.lastChild;
            }
            if (isDetached) {
                var currentLast = currentLastElem.nodeName === 'BR' && !isNOU(currentLastElem.previousSibling) ?
                    currentLastElem.previousSibling : currentLastElem;
                this.formatter.editorManager.nodeSelection.setSelectionText(this.contentModule.getDocument(), isSameContainer ? currentLast : currentStartContainer, currentLast, currentStartOffset, (currentLast.nodeName === 'BR' ? 0 : currentLast.textContent.length));
            }
        }
    };
    RichTextEditor.prototype.isFullSelection = function (e) {
        if (e.action === 'select-all') {
            this.isSelectAll = true;
        }
        else if (this.isSelectAll && e.key !== 'Enter') {
            this.resetPreviousKey();
        }
    };
    RichTextEditor.prototype.resetPreviousKey = function () {
        this.isSelectAll = false;
    };
    /**
     * For internal use only - keydown the event handler;
     *
     * @param {KeyboardEvent} e - specifies the event.
     * @returns {void}
     * @private
     * @deprecated
     * @hidden
     */
    RichTextEditor.prototype.keyDown = function (e) {
        if (this.isMediaUploading()) {
            // To prevent any editor content changes while uploading is happening
            e.preventDefault();
            return;
        }
        this.isSelectionStartInRTE = true;
        this.isFullTableDeleted = false;
        this.isFullSelection(e);
        var isMacDev = this.userAgentData.getPlatform() === 'macOS';
        if (((e.ctrlKey || (e.metaKey && isMacDev)) && e.shiftKey && e.keyCode === 86) ||
            (e.metaKey && isMacDev && e.altKey && e.shiftKey && e.keyCode === 86)) {
            this.isPlainPaste = true;
        }
        if (this.inputElement.classList.contains('e-mention')) {
            var mentionPopup = this.element.ownerDocument.getElementById(this.inputElement.id + '_popup');
            var slashMenuPopup = this.element.ownerDocument.getElementById(this.inputElement.id + '_slash_menu_popup');
            var mentionKeys = mentionRestrictKeys;
            var isMentionKeys = mentionKeys.indexOf(e.key) !== -1;
            var isMentionPopupOpen = mentionPopup && mentionPopup.classList.contains('e-popup-open');
            var isSlashMenuPopupOpen = slashMenuPopup && slashMenuPopup.classList.contains('e-popup-open');
            if (isMentionKeys && (isMentionPopupOpen || isSlashMenuPopupOpen)) {
                return;
            }
        }
        if (this.editorMode === 'HTML' && !isNOU(this.codeBlockModule)) {
            var rangeForCodeBlock = this.getRange();
            if (this.formatter.editorManager.codeBlockObj.isActionDisallowedInCodeBlock(e, rangeForCodeBlock)) {
                e.preventDefault();
                return;
            }
        }
        if (this.enableTabKey) {
            var hasMediaSelected = this.handleMediaTabKey(e);
            if (hasMediaSelected) {
                e.preventDefault();
                return;
            }
        }
        var isCodeBlockEnter = false;
        if (!isNOU(this.codeBlockModule)) {
            var range = this.getRange();
            isCodeBlockEnter = this.formatter.editorManager.codeBlockObj.isCodeBlockEnterAction(range, e);
        }
        this.notify(events.keyDown, { member: 'keydown', args: e });
        if (this.restrict(e)) {
            // to prevent enter key action when max length is reached
            if (e.which === 13) {
                return;
            }
        }
        if (this.editorMode === 'HTML') {
            this.cleanList(e);
        }
        if (this.editorMode === 'HTML' && ((e.which === 8 && e.code === 'Backspace') || (e.which === 46 && e.code === 'Delete'))) {
            var range = this.getRange();
            this.isLastCharInline = range.startContainer && range.startContainer.parentElement &&
                !this.formatter.editorManager.domNode.isBlockNode(range.startContainer.parentElement) &&
                range.startContainer.parentElement.textContent.length === 1;
            var startNode = range.startContainer.nodeName === '#text' ? range.startContainer.parentElement :
                range.startContainer;
            if (closest(startNode, 'pre') &&
                (e.which === 8 && range.startContainer.textContent.charCodeAt(range.startOffset - 1) === 8203) ||
                (e.which === 46 && range.startContainer.textContent.charCodeAt(range.startOffset) === 8203)) {
                var regEx = new RegExp('\u200B', 'g');
                var pointer = e.which === 8 ? range.startOffset - 1 : range.startOffset;
                range.startContainer.textContent = range.startContainer.textContent.replace(regEx, '');
                this.formatter.editorManager.nodeSelection.setCursorPoint(this.contentModule.getDocument(), range.startContainer, pointer);
            }
            else if ((e.code === 'Backspace' && e.which === 8) &&
                range.startContainer.textContent.charCodeAt(0) === 8203 && range.collapsed) {
                var parentEle = range.startContainer.parentElement;
                var index = void 0;
                var i = void 0;
                for (i = 0; i < parentEle.childNodes.length; i++) {
                    if (parentEle.childNodes[i] === range.startContainer) {
                        index = i;
                    }
                }
                var bool = true;
                var removeNodeArray = [];
                for (i = index; i >= 0; i--) {
                    // eslint-disable-next-line max-len
                    if (parentEle.childNodes[i].nodeType === 3 && parentEle.childNodes[i].textContent.charCodeAt(0) === 8203 && bool) {
                        removeNodeArray.push(i);
                    }
                    else {
                        bool = false;
                    }
                }
                if (removeNodeArray.length > 0) {
                    for (i = removeNodeArray.length - 1; i > 0; i--) {
                        parentEle.childNodes[removeNodeArray[i]].textContent = '';
                    }
                }
                this.formatter.editorManager.nodeSelection.setCursorPoint(this.contentModule.getDocument(), range.startContainer, range.startOffset);
            }
        }
        var notFormatPainterCopy = isNOU(e.action) ? true : (e.action !== 'format-copy' ? true : false);
        if (this.formatter.getUndoRedoStack().length === 0 && notFormatPainterCopy &&
            !(e.altKey || (e.shiftKey && e.which === 16) || (e.altKey && e.shiftKey && e.which === 67))) {
            this.formatter.saveData();
        }
        var preventingMention = false;
        var allowInsideCodeBlock = true;
        if (this.editorMode === 'HTML') {
            var range = this.getRange();
            preventingMention = !isNOU(range.startContainer) && range.startContainer === range.endContainer && range.endContainer.childNodes.length > 1 && !isNOU(range.startContainer.childNodes[range.startOffset - 1]) && range.startContainer.childNodes[range.startOffset - 1].nodeName === '#text' && !isNOU(range.startContainer.childNodes[range.startOffset - 1].previousSibling) && range.startContainer.childNodes[range.startOffset - 1].textContent.charCodeAt(0) === 32 && range.startContainer.childNodes[range.startOffset - 1].previousSibling.nodeName !== '#text' && range.startContainer.childNodes[range.startOffset - 1].previousSibling.classList.contains('e-mention-chip');
            if (!isNOU(this.codeBlockModule)) {
                var startInCodeBlock = this.formatter.editorManager.codeBlockObj.isValidCodeBlockStructure(range.startContainer);
                var endInCodeBlock = this.formatter.editorManager.codeBlockObj.isValidCodeBlockStructure(range.endContainer);
                var codeBlockElement = !isNOU(startInCodeBlock) || !isNOU(endInCodeBlock);
                if (codeBlockElement) {
                    var currentAction = e.action;
                    var allowActions = ['undo', 'redo', 'indents', 'outdents', 'ordered-list', 'unordered-list'];
                    allowInsideCodeBlock = allowActions.indexOf(currentAction) !== -1;
                }
            }
        }
        var keyboardEventAction = ['insert-link', 'format-copy', 'format-paste', 'insert-image', 'insert-table', 'insert-audio', 'insert-video'];
        if (keyboardEventAction.indexOf(e.action) === -1 &&
            (!e.target || !(e.target.classList.contains('e-mention') && !isNOU(document.querySelector('#' + e.target.id + '_popup.e-popup-open')) && e.code === 'Tab')) &&
            (e.action && e.action !== 'paste' && e.action !== 'space'
                || e.which === 9 || (e.code === 'Backspace' && e.which === 8)) && !preventingMention) {
            var FormatPainterEscapeAction = false;
            if (!isNOU(this.formatPainterModule)) {
                FormatPainterEscapeAction = this.formatPainterModule.previousAction === 'escape';
            }
            var isUndoRedoAction = e.action === 'undo' || e.action === 'redo';
            if ((!FormatPainterEscapeAction || isUndoRedoAction) && allowInsideCodeBlock && !isCodeBlockEnter) {
                if (this.editorMode === 'HTML' && (e.action === 'increase-fontsize' || e.action === 'decrease-fontsize')) {
                    this.notify(events.onHandleFontsizeChange, { member: 'onHandleFontsizeChange', args: e });
                }
                else {
                    this.formatter.process(this, null, e);
                }
            }
            switch (e.action) {
                case 'toolbar-focus':
                    if (this.toolbarSettings.enable && this.getToolbarElement()) {
                        // Check if cursor is on a link; if so, show link quick toolbar
                        if (this.editorMode === 'HTML') {
                            var range = this.getRange();
                            var selectedStartNode = range.startContainer.nodeName === '#text' ?
                                range.startContainer.parentElement : range.startContainer;
                            var selectedEndNode = range.endContainer.nodeName === '#text' ?
                                range.endContainer.parentElement : range.endContainer;
                            if (selectedStartNode.closest('a') && selectedEndNode.closest('a') && range.collapsed) {
                                this.quickToolbarModule.linkQTBar.showPopup(selectedStartNode.closest('a'), e);
                            }
                        }
                        if (this.userAgentData.isSafari() && e.type === 'keydown' && this.formatter.editorManager.nodeSelection &&
                            this.formatter.editorManager.nodeSelection.get(this.contentModule.getDocument()).rangeCount > 0 &&
                            this.inputElement.contains(this.getRange().startContainer)) {
                            this.notify(events.selectionSave, {});
                        }
                        var toolbarFocusType = 'toolbar';
                        var firstActiveItem = this.getToolbarElement().querySelector('.e-toolbar-item:not(.e-overlay)[title]');
                        var quickToolbarElem = this.getRenderedQuickToolbarElem();
                        if (quickToolbarElem) {
                            firstActiveItem = quickToolbarElem.querySelector('.e-toolbar-item:not(.e-overlay)[title]');
                            toolbarFocusType = 'quickToolbar';
                        }
                        if (firstActiveItem) {
                            var firstChild = firstActiveItem.firstElementChild;
                            firstChild.removeAttribute('tabindex');
                            firstChild.focus();
                            if (this.userAgentData.isSafari() && (toolbarFocusType === 'toolbar' || toolbarFocusType === 'quickToolbar')) {
                                this.inputElement.ownerDocument.getSelection().removeAllRanges();
                            }
                        }
                    }
                    break;
                case 'escape':
                    this.contentModule.getEditPanel().focus();
                    break;
            }
        }
        var isDeleteAction = this.editorMode === 'HTML' && !isNOU(e) && !isNOU(e.code) && (e.code === 'Backspace' || e.code === 'Delete');
        if (isDeleteAction && this.htmlEditorModule.isCopyAll) {
            var brElement = this.createElement('br');
            var newElement = this.enterKey === 'BR' ? brElement : this.createElement(this.enterKey).appendChild(brElement).parentElement;
            this.inputElement.innerHTML = '';
            this.inputElement.appendChild(newElement);
            this.formatter.editorManager.nodeSelection.setCursorPoint(this.contentModule.getDocument(), brElement.parentElement, 0);
            this.htmlEditorModule.isCopyAll = false;
        }
        this.notify(events.afterKeyDown, { member: 'afterKeyDown', args: e });
        this.autoResize();
        if (!isNOU(this.placeholder)) {
            this.setPlaceHolder();
        }
        if (isDeleteAction) {
            if (this.isEntireRTEContentSelected()) {
                this.isCopyAll = true;
            }
        }
        // Cmd + Backspace triggers only the keydown event; the keyup event is not triggered.
        if (e.metaKey && e.key === 'Backspace' && this.autoSaveOnIdle) {
            this.keyUp(e);
        }
        if (this.editorMode === 'HTML') {
            var selection = this.contentModule.getDocument().getSelection();
            var range = selection && selection.getRangeAt(0);
            this.previousRange = range && range.cloneRange();
        }
    };
    RichTextEditor.prototype.handleMediaTabKey = function (e) {
        if (this.quickToolbarModule && !e.altKey && e.key !== 'F10' && e.action !== 'toolbar-focus') {
            this.quickToolbarModule.hideQuickToolbars();
        }
        if (e.key === 'Tab' && this.editorMode === 'HTML') {
            var range = this.getRange();
            var isCollapsed = range.startContainer === range.endContainer && range.startOffset === range.endOffset;
            if (!isCollapsed) {
                var hasMediaSelected = this.isMediaElementSelected(range);
                if (hasMediaSelected) {
                    var isImageResize = this.imageModule && this.imageModule.imgResizeDiv ? true : false;
                    var isVideoResize = this.videoModule && this.videoModule.vidResizeDiv ? true : false;
                    if (isImageResize) {
                        this.imageModule.cancelResizeAction();
                    }
                    if (isVideoResize) {
                        this.videoModule.cancelResizeAction();
                    }
                }
                return hasMediaSelected;
            }
        }
        return false;
    };
    RichTextEditor.prototype.isMediaElementSelected = function (range) {
        if (range.startContainer.nodeType !== Node.TEXT_NODE && range.endContainer.nodeType !== Node.TEXT_NODE) {
            var closestBlockEle = this.formatter.editorManager.domTree.getParentBlockNode(range.startContainer);
            var startContainer = range.startContainer;
            if (startContainer === closestBlockEle && closestBlockEle.childNodes.length > range.startOffset) {
                return startContainer.childNodes[range.startOffset].nodeName === 'IMG';
            }
            else if (startContainer.closest('.e-img-caption-container')) {
                return true;
            }
            else if (startContainer.closest('.e-video-wrap') || startContainer.closest('.e-embed-video-wrap')) {
                return true;
            }
        }
        return false;
    };
    // Clear selection timeout for keyup event triggering
    RichTextEditor.prototype.clearSelectionTimeout = function () {
        if (this.selectionTimeout) {
            clearTimeout(this.selectionTimeout);
            this.selectionTimeout = null;
        }
    };
    // Triggers the selectionChanged event
    RichTextEditor.prototype.triggerSelectionChanged = function () {
        var selection = this.contentModule.getDocument().getSelection();
        var currentRange = selection && selection.rangeCount > 0 && selection.getRangeAt(0);
        if (!this.isSelectionCollapsed()) {
            var isSamerange = this.previousRange &&
                (this.previousRange.startContainer === currentRange.startContainer
                    && this.previousRange.endContainer === currentRange.endContainer
                    && this.previousRange.startOffset === currentRange.startOffset
                    && this.previousRange.endOffset === currentRange.endOffset);
            if (!isSamerange) {
                var selectionArgs = {
                    selectedContent: this.getSelectedHtml(),
                    selection: selection,
                    editorMode: this.editorMode
                };
                this.trigger(events.selectionChanged, selectionArgs);
                this.previousRange = currentRange.cloneRange();
            }
        }
    };
    RichTextEditor.prototype.keyUp = function (e) {
        var _this = this;
        if (this.isMediaUploading()) {
            // To prevent any editor content changes while uploading is happening
            e.preventDefault();
            return;
        }
        if (this.restrict(e)) {
            // to prevent enter key action when max length is reached
            if (e.which === 13) {
                return;
            }
        }
        if (this.inputElement.classList.contains('e-mention')) {
            var mentionPopup = this.element.ownerDocument.getElementById(this.inputElement.id + '_popup');
            var slashMenuPopup = this.element.ownerDocument.getElementById(this.inputElement.id + '_slash_menu_popup');
            var isMentionPopupOpen = mentionPopup && mentionPopup.classList.contains('e-popup-open');
            var isSlashMenuPopupOpen = slashMenuPopup && slashMenuPopup.classList.contains('e-popup-open');
            if ((isMentionPopupOpen || isSlashMenuPopupOpen)) {
                return;
            }
        }
        if (this.editorMode === 'HTML') {
            var range = this.getRange();
            if (!isNOU(e) && !isNOU(e.code) && (e.code === 'Backspace' || e.code === 'Delete' || e.code === 'KeyX')) {
                // To prevent the reformatting the content removed browser behavior.
                var currentRange = this.getRange();
                var selection = this.iframeSettings.enable ? this.contentModule.getPanel().ownerDocument.getSelection() :
                    this.contentModule.getDocument().getSelection();
                if (this.isCopyAll) {
                    var brElement = this.createElement('br');
                    var newElement = this.enterKey === 'BR' ? brElement : this.createElement(this.enterKey).appendChild(brElement).parentElement;
                    this.inputElement.innerHTML = '';
                    this.inputElement.appendChild(newElement);
                    this.formatter.editorManager.nodeSelection.setCursorPoint(this.contentModule.getDocument(), brElement.parentElement, 0);
                    this.isCopyAll = false;
                }
                if (this.isLastCharInline) {
                    selection.removeAllRanges();
                    selection.addRange(currentRange);
                    this.isLastCharInline = false;
                }
            }
            if (Browser.userAgent.indexOf('Firefox') !== -1 && range.startContainer.nodeName === '#text' &&
                range.startContainer.parentElement === this.inputElement && this.enterKey !== 'BR') {
                var range_1 = this.getRange();
                var tempElem = this.createElement(this.enterKey);
                range_1.startContainer.parentElement.insertBefore(tempElem, range_1.startContainer);
                tempElem.appendChild(range_1.startContainer);
                this.formatter.editorManager.nodeSelection.setSelectionText(this.contentModule.getDocument(), tempElem.childNodes[0], tempElem.childNodes[0], tempElem.childNodes[0].textContent.length, tempElem.childNodes[0].textContent.length);
            }
        }
        var currentStackIndex = this.formatter.getCurrentStackIndex();
        if (currentStackIndex === 0) {
            this.updateUndoRedoStack(e);
        }
        this.notify(events.keyUp, { member: 'keyup', args: e });
        this.notify(events.tableModulekeyUp, { member: 'tableModulekeyUp', args: e });
        if (e.code === 'KeyX' && e.which === 88 && e.keyCode === 88 && e.ctrlKey && (this.inputElement.innerHTML === '' ||
            this.inputElement.innerHTML === '<br>')) {
            this.inputElement.innerHTML = resetContentEditableElements(getEditValue(getDefaultValue(this), this), this.editorMode);
        }
        var isMention = this.inputElement.classList.contains('e-mention');
        var allowedKeys = e.which === 32 || e.which === 13 || e.which === 8 || e.which === 46 || e.which === 9 && isMention;
        var formatPainterCopy = e.key === 'C' && e.altKey && e.shiftKey;
        var formatPainterPaste = e.key === 'V' && e.altKey && e.shiftKey;
        if ((!formatPainterCopy && !formatPainterPaste) && !this.isFullTableDeleted && ((e.key !== 'shift' && !e.ctrlKey) && e.key && e.key.length === 1 || allowedKeys) || (this.editorMode === 'Markdown'
            && ((e.key !== 'shift' && !e.ctrlKey) && e.key && e.key.length === 1 || allowedKeys)) || (this.autoSaveOnIdle && Browser.isDevice) && !this.inlineMode.enable) {
            this.formatter.onKeyHandler(this, e);
        }
        if (this.inputElement && this.inputElement.textContent.length !== 0
            || this.element.querySelectorAll('.e-toolbar-item.e-active').length > 0 || this.formatter.getUndoRedoStack().length > 0) {
            this.notify(events.toolbarRefresh, { args: e });
        }
        this.setPlaceHolder();
        if (this.editorMode === 'HTML') {
            //Clears the selectionTimeout and triggers the selectionChanged event.
            this.clearSelectionTimeout();
            var isRteUnitTesting = (this.element && this.element.dataset && this.element.dataset.rteUnitTesting === 'true');
            if (isRteUnitTesting) {
                if (this.isSelecting) {
                    this.triggerSelectionChanged();
                    this.isSelecting = false;
                    this.isSelectionStartInRTE = false;
                }
            }
            else {
                this.selectionTimeout = window.setTimeout(function () {
                    if (_this.isSelecting) {
                        _this.triggerSelectionChanged();
                        _this.isSelecting = false;
                        _this.isSelectionStartInRTE = false;
                    }
                }, 600);
            }
        }
    };
    /**
     * @param {string} value - specifies the value.
     * @returns {void}
     * @hidden
     * @deprecated
     */
    RichTextEditor.prototype.serializeValue = function (value) {
        if (this.editorMode === 'HTML' && !isNOU(value)) {
            if (this.enableHtmlEncode) {
                value = this.htmlEditorModule.sanitizeHelper(decode(value));
                value = this.encode(value);
            }
            else {
                value = this.htmlEditorModule.sanitizeHelper(value);
                value = this.enableXhtml ? this.htmlEditorModule.xhtmlValidation.selfEncloseValidation(value) : value;
            }
            value = cleanHTMLString(value, this.element);
            if (!this.enableXhtml) {
                value = getStructuredHtml(value, this.enterKey, this.enableHtmlEncode);
            }
        }
        return value;
    };
    /**
     * Sanitizes an HTML string to prevent cross-site scripting (XSS) attacks.
     * This method is applicable when the editor mode is specifically set to `HTML`.
     *
     * @param {string} value - The HTML content to be sanitized for security purposes.
     * @returns {string} - The HTML content after being sanitized.
     */
    RichTextEditor.prototype.sanitizeHtml = function (value) {
        return this.serializeValue(value);
    };
    /**
     * updateValue method
     *
     * @param {string} value - specifies the string value.
     * @returns {void}
     * @hidden
     * @deprecated
     */
    RichTextEditor.prototype.updateValue = function (value) {
        if (isNOU(value)) {
            var inputVal = this.inputElement.innerHTML;
            this.setProperties({ value: isEditableValueEmpty(inputVal) ? null : inputVal });
        }
        else {
            this.setProperties({ value: value });
        }
    };
    RichTextEditor.prototype.triggerEditArea = function (e) {
        if (!isIDevice()) {
            this.notify(events.editAreaClick, { member: 'editAreaClick', args: e });
        }
        else {
            var touch = (e.touches ? e.changedTouches[0] : e);
            if (this.clickPoints.clientX === touch.clientX && this.clickPoints.clientY === touch.clientY) {
                this.notify(events.editAreaClick, { member: 'editAreaClick', args: e });
            }
        }
    };
    RichTextEditor.prototype.focusHR = function (e) {
        if (e.target.tagName === 'HR') {
            e.target.classList.add('e-rte-hr-focus');
        }
    };
    RichTextEditor.prototype.notifyMouseUp = function (e) {
        var touch = (e.touches ? e.changedTouches[0] : e);
        this.notify(events.mouseUp, {
            member: 'mouseUp', args: e,
            touchData: {
                prevClientX: this.clickPoints.clientX, prevClientY: this.clickPoints.clientY,
                clientX: touch.clientX, clientY: touch.clientY
            }
        });
        if (this.inputElement && ((this.editorMode === 'HTML' && ((this.inputElement.textContent.length !== 0) || e.target && !isNOU(e.target.querySelector('li')))) ||
            (this.editorMode === 'Markdown' && this.inputElement.value.length !== 0)) ||
            (e.target && !isNOU(closest(e.target, 'table'))) ||
            (e.target && !isNOU(e.target.querySelector('img'))) ||
            (e.target && (e.target.nodeName === 'VIDEO' ||
                e.target.querySelectorAll('.' + classes.CLS_VIDEOWRAP).length > 0) ||
                (e.target && e.target.nodeName !== 'BR' &&
                    (e.target.classList.contains(classes.CLS_AUDIOWRAP) ||
                        e.target.classList.contains(classes.CLS_CLICKELEM) ||
                        e.target.classList.contains(classes.CLS_VID_CLICK_ELEM))))) {
            this.notify(events.toolbarRefresh, { args: e });
        }
        this.triggerEditArea(e);
        if (this.editorMode === 'HTML') {
            this.focusHR(e);
        }
    };
    RichTextEditor.prototype.updateUndoRedoStack = function (e, selectionChange) {
        var undoRedoStack = this.formatter.getUndoRedoStack();
        var currentStackIndex = this.formatter.getCurrentStackIndex();
        var navigationKeys = [
            'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown',
            'Home', 'End', 'PageUp', 'PageDown'
        ];
        var isNavKey = navigationKeys.indexOf(e.key) !== -1;
        var isNavigationKey = e.type === 'keyup' ? isNavKey : true;
        if (undoRedoStack.length === 0 || currentStackIndex === 0) {
            if (undoRedoStack.length === 0) {
                this.formatter.saveData();
            }
            else if ((currentStackIndex === 0 && this.editorMode === 'HTML') && (isNavigationKey || selectionChange)) {
                var firstStackState = undoRedoStack[0];
                var save = new NodeSelection(this.inputElement)
                    .save(this.getRange(), this.contentModule.getDocument());
                firstStackState.range = save;
            }
            else if (currentStackIndex === 0 && this.editorMode === 'Markdown' && isNavigationKey) {
                var markdownFirstStackState = undoRedoStack[0];
                var start = this.inputElement.selectionStart;
                var end = this.inputElement.selectionEnd;
                markdownFirstStackState.start = start;
                markdownFirstStackState.end = end;
            }
        }
    };
    RichTextEditor.prototype.mouseUp = function (e) {
        this.isSelectionStartInRTE = false;
        if (this.isSelectionCollapsed()) {
            var selection = this.contentModule.getDocument().getSelection();
            var range = selection && selection.rangeCount !== 0 && selection.getRangeAt(0);
            this.previousRange = range && range.cloneRange();
        }
        var target = e.target;
        var mediaTags = ['IMG', 'VIDEO', 'AUDIO', 'TABLE', 'TH', 'TD', 'TR', 'TBODY'];
        var isNotMediaElement = !(target && mediaTags.indexOf(target.tagName) !== -1 || (target.nodeName !== '#text' &&
            (target.closest('.e-audio-wrap') || target.closest('.e-video-wrap') || target.closest('.e-embed-video-wrap'))));
        var hasTableCellSelection = false;
        if (e.target instanceof HTMLElement && e.target.parentElement && e.target.parentElement.tagName === 'SPAN') {
            var targetEle_1 = e.target.parentElement;
            var iconClassSets = [['e-row-wrapper'], ['e-col-wrapper'], ['e-table-wrapper']];
            if (iconClassSets.some(function (set) { return set.every(function (cls) { return targetEle_1.classList.contains(cls); }); })) {
                hasTableCellSelection = true;
            }
        }
        if (isNotMediaElement && !hasTableCellSelection && this.editorMode === 'HTML' && !(Browser.isDevice || isIDevice())) {
            if (!this.isSelectionInRTE()) {
                return;
            }
        }
        if (this.quickToolbarSettings.showOnRightClick && Browser.isDevice) {
            var target_1 = e.target;
            var closestTable = closest(target_1, 'table');
            if (target_1 && target_1.nodeName === 'A' || target_1.nodeName === 'IMG' || (target_1.nodeName === 'TD' || target_1.nodeName === 'TH' ||
                target_1.nodeName === 'TABLE' || (closestTable && this.contentModule.getEditPanel().contains(closestTable)))) {
                return;
            }
        }
        this.notifyMouseUp(e);
        this.setPlaceHolder();
        this.autoResize();
        this.notify(EVENTS.touchEnd, e);
        this.updateUndoRedoStack(e);
        if (this.isSelectionInRTE()) {
            this.triggerSelectionChanged();
            this.isSelecting = false;
        }
    };
    /**
     * @param {Function} module - specifies the module function.
     * @returns {void}
     * @hidden
     * @deprecated
     */
    RichTextEditor.prototype.ensureModuleInjected = function (module) {
        return this.getInjectedModules().indexOf(module) >= 0;
    };
    /**
     * Handles clipboard events to prevent default browser behavior for cut and copy operations
     *
     * @param {ClipboardEvent} e - The clipboard event object
     * @returns {void}
     * @hidden
     * @deprecated
     */
    RichTextEditor.prototype.clipBoardHandler = function (e) {
        if (!isNullOrUndefined(e) && this.editorMode === 'HTML') {
            if ((e.type === 'copy' && this.handleTableCellCopy(e)) ||
                (e.type === 'cut' && this.handleTableCellCopy(e, true))) {
                // Copy and cut was handled by table module
                e.preventDefault();
                return;
            }
            var range = this.getRange();
            if (!isNOU(range)) {
                var collapsed = (range.startContainer === range.endContainer) &&
                    range.startOffset === range.endOffset;
                var isModuleAndPropertyEnabled = this.enableClipboardCleanup && !isNOU(this.clipBoardCleanupModule);
                if (isModuleAndPropertyEnabled && !collapsed &&
                    !isNOU(e.clipboardData)) {
                    this.notify(events.clipBoardCleanup, { args: e });
                    if (e.type === 'copy' && !this.isToolbarClipboardAction) {
                        this.formatter.onSuccess(this, {
                            requestType: 'Copy',
                            editorMode: this.editorMode,
                            event: e
                        });
                    }
                    else if (e.type === 'cut' && !this.isToolbarClipboardAction) {
                        this.formatter.onSuccess(this, {
                            requestType: 'Cut',
                            editorMode: this.editorMode,
                            event: e
                        });
                    }
                    e.preventDefault();
                }
                if (isNOU(this.clipBoardCleanupModule) && this.enableClipboardCleanup) {
                    console.warn('[WARNING] :: Module "clipBoardCleanup" is not available in RichTextEditor component! You either misspelled the module name or forgot to load it.');
                }
            }
            this.notify(EVENTS.cut, e);
            if (!isNOU(e.type) && e.type === 'cut' && !isNOU(this.quickToolbarModule)) {
                this.quickToolbarModule.hideQuickToolbars();
            }
        }
        this.isToolbarClipboardAction = false;
    };
    /**
     * @param {MouseEvent | KeyboardEvent | ClipboardEvent} e - specifies the event.
     * @returns {void}
     * @hidden
     * @deprecated
     */
    RichTextEditor.prototype.onCopy = function (e) {
        if (e === void 0) { e = null; }
        this.isToolbarClipboardAction = true;
        this.contentModule.getDocument().execCommand('copy', false, null);
    };
    /**
     * @param {MouseEvent | KeyboardEvent | ClipboardEvent} e - specifies the event.
     * @returns {void}
     * @hidden
     * @deprecated
     */
    RichTextEditor.prototype.onCut = function (e) {
        if (e === void 0) { e = null; }
        var range = this.contentModule.getDocument().getSelection().getRangeAt(0);
        var div = document.createElement('div');
        div.appendChild(range.cloneContents());
        var selectedHTML = div.innerHTML;
        if (selectedHTML === this.inputElement.innerHTML ||
            (range.commonAncestorContainer === this.inputElement && selectedHTML === this.inputElement.textContent.trim())) {
            this.isCopyAll = true;
        }
        this.isToolbarClipboardAction = true;
        this.contentModule.getDocument().execCommand('cut', false, null);
    };
    /**
     * @param {KeyboardEvent} e - specifies the keyboard event.
     * @returns {void}
     * @hidden
     * @deprecated
     */
    RichTextEditor.prototype.onPaste = function (e) {
        var _this = this;
        var evenArgs = {
            originalEvent: e,
            cancel: false,
            requestType: 'Paste'
        };
        this.isPlainPaste = e && e.clipboardData && e.clipboardData.items && e.clipboardData.items.length
            && e.clipboardData.items.length === 1 && e.clipboardData.items[0].type === 'text/plain';
        this.trigger(events.actionBegin, evenArgs, function (pasteArgs) {
            var currentLength = _this.getText().replace(/\u200B/g, '').replace(_this.editorMode === 'HTML' ? /(\r\n|\n|\r|\t)/gm : '', '').length;
            var selectionLength = _this.getSelection().length;
            var pastedContentLength = (isNOU(e) || isNOU(e.clipboardData))
                ? 0 : e.clipboardData.getData('text/plain').replace(/(\r\n|\n|\r|\t)/gm, '').replace(/\u200B/g, '').length;
            var totalLength = (currentLength - selectionLength) + pastedContentLength;
            if (_this.editorMode === 'Markdown') {
                var args_1 = { requestType: 'Paste', editorMode: _this.editorMode, event: e };
                setTimeout(function () {
                    _this.formatter.onSuccess(_this, args_1);
                }, 0);
                if (!(_this.maxLength === -1 || totalLength <= _this.maxLength)) {
                    e.preventDefault();
                }
                return;
            }
            if (!pasteArgs.cancel && _this.inputElement.contentEditable === 'true' &&
                (_this.maxLength === -1 || totalLength <= _this.maxLength)) {
                var currentRange = _this.getRange();
                var codeBlockPasteAction = void 0;
                if (!isNOU(_this.codeBlockModule)) {
                    codeBlockPasteAction = (_this.formatter.editorManager.codeBlockObj.
                        isValidCodeBlockStructure(currentRange.startContainer)
                        || _this.formatter.editorManager.codeBlockObj.isValidCodeBlockStructure(currentRange.endContainer));
                }
                var isImageDialogOpen = _this.contentModule.getDocument().querySelector('.e-rte-img-dialog');
                if (!isNOU(_this.pasteCleanupModule) && isNOU(codeBlockPasteAction)) {
                    if (isNOU(isImageDialogOpen)) {
                        _this.notify(events.pasteClean, { args: e, isPlainPaste: _this.isPlainPaste });
                    }
                }
                else {
                    if (!_this.isPlainPaste) {
                        console.warn('[WARNING] :: Module "pasteCleanup" is not available in RichTextEditor component! You either misspelled the module name or forgot to load it.');
                        var args_2 = { requestType: 'Paste', editorMode: _this.editorMode, event: e };
                        var value = null;
                        var htmlValue = false;
                        if (e && !isNOU(e.clipboardData)) {
                            value = e.clipboardData.getData('text/plain');
                            htmlValue = e.clipboardData.getData('text/html').indexOf('MsoNormal') > 0;
                        }
                        var file = e && e.clipboardData && e.clipboardData.items.length > 0 ?
                            e.clipboardData.items[0].getAsFile() : null;
                        var files = [];
                        if (e && e.clipboardData && e.clipboardData.items.length > 0) {
                            for (var i = 0; i < e.clipboardData.items.length; i++) {
                                // eslint-disable-next-line
                                var currentFile = e.clipboardData.items[i].getAsFile();
                                files.push(currentFile);
                            }
                        }
                        if (value !== null && isNOU(codeBlockPasteAction)) {
                            var images = [];
                            var videos = [];
                            var audios = [];
                            var audioAllowedTypes = _this.insertAudioSettings && _this.insertAudioSettings.allowedTypes ?
                                _this.insertAudioSettings.allowedTypes : [];
                            var videoAllowedTypes = _this.insertVideoSettings && _this.insertVideoSettings.allowedTypes ?
                                _this.insertVideoSettings.allowedTypes : [];
                            var _loop_1 = function (f) {
                                if (!f) {
                                    return "continue";
                                }
                                var mime = (f.type || '').toLowerCase();
                                if (mime.indexOf('image/') === 0) {
                                    images.push(f);
                                }
                                else if (mime.indexOf('video/') === 0 &&
                                    videoAllowedTypes.some(function (ext) { return mime.endsWith(ext.replace('.', '')); })) {
                                    videos.push(f);
                                }
                                else if (mime.indexOf('audio/') === 0 &&
                                    audioAllowedTypes.some(function (ext) { return mime.endsWith(ext.replace('.', '')); })) {
                                    audios.push(f);
                                }
                            };
                            for (var _i = 0, files_1 = files; _i < files_1.length; _i++) {
                                var f = files_1[_i];
                                _loop_1(f);
                            }
                            if (images.length > 0) {
                                _this.notify(events.paste, { file: images, args: e, text: value, isWordPaste: htmlValue });
                            }
                            if (videos.length > 0) {
                                _this.notify(events.videoPaste, { file: videos, args: e, text: value, isWordPaste: htmlValue });
                            }
                            if (audios.length > 0) {
                                _this.notify(events.audioPaste, { file: audios, args: e, text: value, isWordPaste: htmlValue });
                            }
                        }
                        else if (value !== null && !isNOU(codeBlockPasteAction) && !isNOU(_this.codeBlockModule)) {
                            _this.notify(events.codeBlockPaste, {
                                file: file,
                                args: e,
                                text: value,
                                isWordPaste: htmlValue
                            });
                        }
                        setTimeout(function () {
                            _this.formatter.onSuccess(_this, args_2);
                        }, 0);
                    }
                    else if (_this.isPlainPaste && !isNOU(codeBlockPasteAction) && !isNOU(_this.codeBlockModule)) {
                        _this.notify(events.codeBlockPaste, {
                            args: e
                        });
                    }
                }
            }
            else {
                e.preventDefault();
            }
        });
        if (!isNOU(e) && !isNOU(e.type) && e.type === 'paste' && !isNOU(this.quickToolbarModule)) {
            this.quickToolbarModule.hideQuickToolbars();
        }
        this.isPlainPaste = false;
    };
    /**
     * @param {string} action - specifies the string value.
     * @param {MouseEvent} event - specifies the event.
     * @returns {void}
     * @hidden
     * @deprecated
     */
    RichTextEditor.prototype.clipboardAction = function (action, event) {
        switch (action.toLowerCase()) {
            case 'cut':
                this.onCut(event);
                this.formatter.onSuccess(this, {
                    requestType: 'Cut',
                    editorMode: this.editorMode,
                    event: event
                });
                break;
            case 'copy':
                this.onCopy(event);
                this.formatter.onSuccess(this, {
                    requestType: 'Copy',
                    editorMode: this.editorMode,
                    event: event
                });
                break;
            case 'paste':
                this.onPaste(event);
                break;
        }
    };
    /**
     * Destroys the component by detaching or removing all event handlers,
     * attributes, and CSS classes. It also clears the component's element content.
     *
     * @returns {void}
     */
    RichTextEditor.prototype.destroy = function () {
        if (this.isDestroyed || !this.isRendered) {
            return;
        }
        this.element.className = this.beforeRenderClassValue;
        this.removeHtmlAttributes();
        this.removeAttributes();
        this.beforeRenderClassValue = null;
        if (!isNOU(this.timeInterval)) {
            clearInterval(this.timeInterval);
            this.timeInterval = null;
        }
        if (!isNOU(this.autoSaveTimeOut)) {
            clearTimeout(this.autoSaveTimeOut);
            this.autoSaveTimeOut = null;
        }
        if (!isNOU(this.idleInterval)) {
            clearTimeout(this.idleInterval);
            this.idleInterval = null;
        }
        this.notify(events.destroy, {});
        this.destroyDependentModules();
        this.unWireEvents();
        if (this.originalElement.tagName === 'TEXTAREA') {
            this.element.parentElement.insertBefore(this.valueContainer, this.element);
            this.valueContainer.id = this.getID();
            this.valueContainer.removeAttribute('name');
            detach(this.element);
            if (this.originalElement.innerHTML.trim() !== '') {
                this.valueContainer.value = this.originalElement.innerHTML.trim();
                this.setProperties({ value: (!isNOU(this.initialValue) ? this.initialValue : null) }, true);
            }
            else {
                this.valueContainer.value = this.valueContainer.defaultValue;
            }
            this.element = this.valueContainer;
            for (var i = 0; i < this.originalElement.classList.length; i++) {
                addClass([this.element], this.originalElement.classList[i]);
            }
            if (!isNOU(this.cssClass)) {
                var currentClassList = this.cssClass.split(' ');
                for (var i = 0; i < currentClassList.length; i++) {
                    addClass([this.element], currentClassList[i]);
                }
            }
            removeClass([this.element], classes.CLS_RTE_HIDDEN);
        }
        else {
            if (this.originalElement.innerHTML.trim() !== '') {
                this.element.innerHTML = this.originalElement.innerHTML.trim();
                this.setProperties({ value: (!isNOU(this.initialValue) ? this.initialValue : null) }, true);
            }
            else {
                this.element.innerHTML = '';
            }
        }
        var dialogElement = document.querySelector('.e-dialog.e-rte-elements');
        if (dialogElement) {
            detach(dialogElement);
        }
        if (this.placeholder && this.placeHolderWrapper) {
            this.placeHolderWrapper = null;
        }
        if (!isNOU(this.cssClass)) {
            var allClassName = this.cssClass.split(' ');
            for (var i = 0; i < allClassName.length; i++) {
                if (allClassName[i].trim() !== '') {
                    removeClass([this.element], allClassName[i]);
                }
            }
        }
        if (this.rootContainer) {
            this.rootContainer = null;
        }
        if (this.valueContainer) {
            this.valueContainer = null;
        }
        if (this.originalElement) {
            this.originalElement = null;
        }
        this.currentTarget = null;
        this.scrollParentElements = [];
        this.userAgentData = null;
        this.isRendered = false;
        this.isSelecting = false;
        this.selectionTimeout = null;
        this.previousRange = null;
        this.isRTEFocused = false;
        this.isFullTableDeleted = false;
        this.isModalDialog = false;
        this.isLastCharInline = false;
        _super.prototype.destroy.call(this);
    };
    /*
     * Handles table cell copy operation when cells are selected.
     */
    RichTextEditor.prototype.handleTableCellCopy = function (e, isCut) {
        if (isCut === void 0) { isCut = false; }
        var range = this.getRange();
        if (range &&
            range.startContainer &&
            this.tableModule &&
            this.tableModule.tableObj &&
            this.tableModule.tableObj.curTable &&
            this.tableModule.tableObj.curTable.contains(range.startContainer) &&
            this.tableModule.tableObj.curTable.querySelectorAll('.e-cell-select.e-multi-cells-select').length > 0) {
            var processedTableContent = this.tableModule.tableObj.copy(isCut);
            if (!isNOU(processedTableContent)) {
                processedTableContent = sanitizeHelper(processedTableContent, this);
                e.clipboardData.setData('text/html', processedTableContent);
            }
            return true;
        }
        return false;
    };
    RichTextEditor.prototype.removeHtmlAttributes = function () {
        if (this.htmlAttributes) {
            var keys = Object.keys(this.htmlAttributes);
            for (var i = 0; i < keys.length && this.element.hasAttribute(keys[i]); i++) {
                this.element.removeAttribute(keys[i]);
            }
        }
    };
    RichTextEditor.prototype.removeAttributes = function () {
        if (!this.enabled) {
            removeClass([this.element], classes.CLS_DISABLED);
        }
        if (this.enableRtl) {
            removeClass([this.element], classes.CLS_RTL);
        }
        if (this.readonly) {
            removeClass([this.element], classes.CLS_RTE_READONLY);
        }
        if (this.element.style.width !== '' && this.originalElement.style.width === '') {
            this.element.style.removeProperty('width');
        }
        if (this.element.style.height !== '' && this.originalElement.style.height === '') {
            this.element.style.removeProperty('height');
        }
        this.element.removeAttribute('aria-disabled');
        this.element.removeAttribute('role');
        this.element.removeAttribute('tabindex');
        this.element.removeAttribute('aria-label');
    };
    RichTextEditor.prototype.destroyDependentModules = function () {
        // To handle the non Injectible module destruction.
        this.renderModule.destroy();
        this.formatter.editorManager.destroy();
    };
    /**
     * Retrieves the HTML or text content inside the RichTextEditor.
     *
     * @returns {Element} - The element containing the content.
     */
    RichTextEditor.prototype.getContent = function () {
        return this.contentModule.getPanel();
    };
    /**
     * Retrieves the text content as a string.
     *
     * @returns {string} - The plain text content.
     */
    RichTextEditor.prototype.getText = function () {
        return this.contentModule.getText();
    };
    /**
     * Retrieves the HTML representation of the selected content as a string.
     *
     * @returns {string} - The HTML content of the selected area.
     */
    RichTextEditor.prototype.getSelectedHtml = function () {
        var range;
        var selectedHtml;
        var selection = this.contentModule.getDocument().getSelection();
        if (selection.rangeCount > 0) {
            range = selection.getRangeAt(0);
            selectedHtml = this.extractContentFromSelection(range.cloneRange());
        }
        return selectedHtml;
    };
    /* Extracts both HTML content from the current selection range. */
    RichTextEditor.prototype.extractContentFromSelection = function (range) {
        var htmlContent = '';
        htmlContent = this.getHTMLFromSelectionRange(range);
        htmlContent = this.normalizeInlineElementWrapping(range, htmlContent);
        return htmlContent;
    };
    /* Extracts HTML content from the current selection range by wrapping it in a temporary container */
    RichTextEditor.prototype.getHTMLFromSelectionRange = function (selectionRange) {
        var clonedSelection = selectionRange.cloneContents();
        var temporaryContainer = this.createElement('div');
        temporaryContainer.appendChild(clonedSelection);
        return temporaryContainer.innerHTML;
    };
    /* Extracts HTML content and ensures inline elements are properly wrapped if present in the selection.*/
    RichTextEditor.prototype.normalizeInlineElementWrapping = function (selectionRange, htmlContent) {
        var startNode = selectionRange.startContainer;
        // Check if the selection starts with non-empty text
        if (startNode.textContent.trim() !== '') {
            var ancestorNode = selectionRange.commonAncestorContainer;
            var isTextNode = ancestorNode.nodeName === '#text';
            var isNonBlockNode = !this.formatter.editorManager.domNode.isBlockNode((isTextNode ? ancestorNode.parentNode : ancestorNode));
            if (isNonBlockNode) {
                htmlContent = this.getWrappedAroundInlineElement((isTextNode ? ancestorNode.parentNode : ancestorNode), htmlContent);
            }
        }
        // Special handling for video wrapper elements
        var isVideoWrapper = startNode.nodeName === 'SPAN' &&
            startNode.classList.length > 0 && startNode.classList.contains('e-video-wrap');
        if (isVideoWrapper) {
            htmlContent = startNode.outerHTML;
        }
        return htmlContent;
    };
    /* Returns the outer HTML of the nearest inline-level ancestor after replacing its inner content with the provided HTML content. */
    RichTextEditor.prototype.getWrappedAroundInlineElement = function (inlineAncestor, contentToWrap) {
        var contentContainer = this.createElement('div');
        contentContainer.innerHTML = contentToWrap;
        //to retrieve only the wrapper inline element without any inner html in it
        do {
            var clonedInlineAncestor = inlineAncestor.cloneNode(true);
            //swapping the existing html and cloned inline wrapper
            clonedInlineAncestor.innerHTML = contentContainer.innerHTML;
            contentContainer.innerHTML = clonedInlineAncestor.outerHTML;
            inlineAncestor = inlineAncestor.parentElement;
        } while (!isNOU(inlineAncestor) && !this.formatter.editorManager.domNode.isBlockNode(inlineAncestor));
        return contentContainer.innerHTML;
    };
    /**
     * Displays the inline quick toolbar.
     *
     * @returns {void}
     */
    RichTextEditor.prototype.showInlineToolbar = function () {
        if (this.inlineMode.enable) {
            var currentRange = this.getRange();
            if (!this.isSelectionInRTE()) {
                var node = this.contentModule.getEditPanel();
                var cursorFocusElement = (this.enterKey === 'BR')
                    ? node.childNodes[0].parentElement
                    : node.childNodes[0];
                this.formatter.editorManager.nodeSelection.setCursorPoint(this.contentModule.getDocument(), cursorFocusElement, 0);
                currentRange = this.getRange();
            }
            var targetElm = currentRange.endContainer.nodeName === '#text' ?
                currentRange.endContainer.parentElement : currentRange.endContainer;
            var rects = Array.from(currentRange.getClientRects(), function (rect) { return rect; });
            if (rects.length === 0) {
                rects = [currentRange.startContainer.getBoundingClientRect()];
            }
            if (rects.length > 0) {
                var x = rects[0].left;
                var y = rects[0].top;
                this.quickToolbarModule.showInlineQTBar(x, y, targetElm);
            }
        }
    };
    /**
     * Hides the inline quick toolbar.
     *
     * @returns {void}
     */
    RichTextEditor.prototype.hideInlineToolbar = function () {
        this.quickToolbarModule.hideInlineQTBar();
    };
    /**
     * For internal use only - Get the module name.
     *
     * @returns {void}
     * @private
     * @deprecated
     */
    RichTextEditor.prototype.getModuleName = function () {
        return 'richtexteditor';
    };
    /**
     * Called internally if any of the property value changed.
     *
     * @param {RichTextEditorModel} newProp - specifies the the property.
     * @param {RichTextEditorModel} oldProp - specifies the old property.
     * @returns {void}
     * @hidden
     * @deprecated
     */
    /* eslint-disable */
    RichTextEditor.prototype.onPropertyChanged = function (newProp, oldProp) {
        for (var _i = 0, _a = Object.keys(newProp); _i < _a.length; _i++) {
            var prop = _a[_i];
            switch (prop) {
                case 'enterKey':
                case 'value': {
                    var nVal = void 0;
                    if (prop === 'enterKey') {
                        if (this.value === null || this.value === '<div><br></div>' || this.value === '<p><br></p>' ||
                            this.value === '<br>') {
                            nVal = null;
                        }
                        else {
                            nVal = this.value;
                        }
                        this.formatter.editorManager.observer.notify(CONSTANT.MODEL_CHANGED, { module: 'enterAction', enterAction: newProp.enterKey });
                    }
                    else {
                        nVal = newProp[prop];
                    }
                    nVal = this.editorMode === 'HTML' ? this.replaceEntities(nVal) : nVal;
                    nVal = this.serializeValue(nVal);
                    var val = this.editorMode === 'HTML' ? getEditValue(nVal, this) : nVal;
                    if ((!isNOU(nVal) && nVal !== '') || prop === 'enterKey') {
                        this.setProperties({ value: ((this.enableHtmlEncode) ? this.encode(decode(val)) : val) }, true);
                    }
                    this.updatePanelValue();
                    if (this.inputElement) {
                        this.notify(events.tableclass, {});
                    }
                    this.setPlaceHolder();
                    this.notify(events.xhtmlValidation, { module: 'XhtmlValidation', newProp: newProp, oldProp: oldProp });
                    if (this.enableXhtml) {
                        this.setProperties({ value: this.getXhtml() }, true);
                    }
                    if (this.showCharCount) {
                        this.countModule.refresh();
                    }
                    this.addAudioVideoWrapper();
                    this.notify(events.toolbarRefresh, {});
                    break;
                }
                case 'valueTemplate':
                    this.setValue(true);
                    if (this.showCharCount) {
                        this.countModule.refresh();
                    }
                    break;
                case 'width':
                    this.setWidth(newProp[prop]);
                    if (this.toolbarSettings.enable && !this.inlineMode.enable) {
                        this.toolbarModule.refreshToolbarOverflow();
                        this.resizeHandler();
                    }
                    break;
                case 'height':
                    this.setHeight(newProp[prop]);
                    this.autoResize();
                    break;
                case 'readonly':
                    this.setReadOnly(false);
                    this.updateUIForReadOnlyState();
                    this.notify(events.modelChanged, { newProp: newProp, oldProp: oldProp });
                    break;
                case 'cssClass':
                    this.updateCssClass(oldProp[prop], false);
                    this.updateCssClass(newProp[prop], true);
                    this.notify(events.bindCssClass, { cssClass: newProp[prop], oldCssClass: oldProp[prop] });
                    break;
                case 'enabled':
                    this.setEnable();
                    break;
                case 'enableRtl':
                    this.updateRTL();
                    break;
                case 'placeholder':
                    this.placeholder = newProp[prop];
                    this.setPlaceHolder();
                    break;
                case 'htmlAttributes':
                    setAttributes(this.htmlAttributes, this, false, false);
                    break;
                case 'iframeSettings': {
                    var frameSetting = oldProp[prop];
                    if (frameSetting.resources) {
                        var iframe = this.contentModule.getDocument();
                        var header = iframe.querySelector('head');
                        var files = void 0;
                        if (frameSetting.resources.scripts) {
                            files = header.querySelectorAll('.' + classes.CLS_SCRIPT_SHEET);
                            this.removeSheets(files);
                        }
                        if (frameSetting.resources.styles) {
                            files = header.querySelectorAll('.' + classes.CLS_STYLE_SHEET);
                            this.removeSheets(files);
                        }
                    }
                    this.setIframeSettings();
                    break;
                }
                case 'locale':
                    _super.prototype.refresh.call(this);
                    break;
                case 'inlineMode':
                    this.notify(events.modelChanged, { module: 'quickToolbar', newProp: newProp, oldProp: oldProp });
                    break;
                case 'toolbarSettings':
                    this.notify(events.modelChanged, { module: 'toolbar', newProp: newProp, oldProp: oldProp });
                    this.updateUIForReadOnlyState();
                    break;
                case 'maxLength':
                    if (this.showCharCount) {
                        this.countModule.refresh();
                    }
                    break;
                case 'showCharCount':
                    if (newProp[prop] && this.countModule) {
                        this.countModule.renderCount();
                    }
                    else if (newProp[prop] === false && this.countModule) {
                        this.countModule.destroy();
                    }
                    break;
                case 'enableHtmlEncode':
                    this.updateValueData();
                    this.updatePanelValue();
                    this.setPlaceHolder();
                    if (this.showCharCount) {
                        this.countModule.refresh();
                    }
                    break;
                case 'undoRedoSteps':
                case 'undoRedoTimer':
                    this.formatter.editorManager.observer.notify(CONSTANT.MODEL_CHANGED, { newProp: newProp, oldProp: oldProp });
                    break;
                case 'enableXhtml':
                    this.notify(events.xhtmlValidation, { module: 'XhtmlValidation', newProp: newProp, oldProp: oldProp });
                    this.inputElement.innerHTML = getStructuredHtml(cleanHTMLString(this.inputElement.innerHTML, this.element), this.enterKey, this.enableHtmlEncode);
                    break;
                case 'quickToolbarSettings':
                    if (!isNOU(newProp.quickToolbarSettings.showOnRightClick)) {
                        newProp.quickToolbarSettings.showOnRightClick ? this.wireContextEvent() : this.unWireContextEvent();
                    }
                    this.notify(events.modelChanged, { newProp: newProp, oldProp: oldProp });
                    break;
                case 'formatPainterSettings':
                    this.formatter.editorManager.observer.notify(CONSTANT.MODEL_CHANGED, { module: 'formatPainter', newProp: newProp });
                    break;
                case 'showTooltip':
                case 'floatingToolbarOffset':
                    this.notify(events.modelChanged, { module: 'toolbar', newProp: newProp, oldProp: oldProp });
                    break;
                case 'keyConfig':
                    Object.assign(this.keyboardModule.keyConfigs, newProp.keyConfig);
                    break;
                default:
                    this.notify(events.modelChanged, { newProp: newProp, oldProp: oldProp });
                    break;
            }
            this.autoResize();
        }
        if (this.formatter) {
            this.notify(events.updateProperty, {});
        }
    };
    /* eslint-enable */
    /**
     * @hidden
     * @returns {void}
     * @deprecated
     */
    RichTextEditor.prototype.updateValueData = function () {
        if (this.enableHtmlEncode) {
            this.setProperties({ value: this.encode(decode(this.inputElement.innerHTML)) }, true);
        }
        else {
            this.setProperties({
                value: /<[a-z][\s\S]*>/i.test(this.inputElement.innerHTML) ? this.inputElement.innerHTML :
                    decode(this.inputElement.innerHTML)
            });
        }
    };
    RichTextEditor.prototype.removeSheets = function (srcList) {
        var i;
        for (i = 0; i < srcList.length; i++) {
            detach(srcList[i]);
        }
    };
    RichTextEditor.prototype.closeAllDialogsAndQuickToolbars = function () {
        if (this.editorMode === 'HTML') {
            if (this.quickToolbarModule) {
                this.quickToolbarModule.hideQuickToolbars();
            }
            if (!isNOU(this.videoModule) && !isNOU(this.videoModule.dialogObj)) {
                this.closeDialog(DialogType.InsertVideo);
            }
            else if (!isNOU(this.tableModule) && !isNOU(this.tableModule.editdlgObj)) {
                this.closeDialog(DialogType.InsertTable);
            }
            else if (!isNOU(this.audioModule) && !isNOU(this.audioModule.dialogObj)) {
                this.closeDialog(DialogType.InsertAudio);
            }
            else if (!isNOU(this.emojiPickerModule) && !isNOU(this.emojiPickerModule.popupObj)) {
                this.emojiPickerModule.popupObj.hide();
            }
            else if (!isNOU(this.tableModule) && !isNOU(this.tableModule.popupObj)) {
                this.tableModule.popupObj.hide();
            }
        }
        if (!isNOU(this.imageModule) && !isNOU(this.imageModule.dialogObj)) {
            this.closeDialog(DialogType.InsertImage);
        }
        else if (!isNOU(this.linkModule) && !isNOU(this.linkModule.dialogObj)) {
            this.closeDialog(DialogType.InsertLink);
        }
    };
    RichTextEditor.prototype.toggleOverlay = function (element, add) {
        if (add) {
            if (element && !element.classList.contains('e-overlay')) {
                element.classList.add('e-overlay');
            }
        }
        else {
            if (element && element.classList.contains('e-overlay')) {
                element.classList.remove('e-overlay');
            }
        }
    };
    /**
     * Syncs the toolbar and related UI with the editor's read-only state.
     * - In read-only: hides dialogs/popups/quick toolbars, removes focus/resize UI, overlays/disable toolbar controls.
     * - In editable: re-enables items and removes overlays, restoring scroll/nav controls as needed.
     */
    RichTextEditor.prototype.updateUIForReadOnlyState = function (initialLoad) {
        if (this.readonly && this.toolbarSettings.enable && !isNOU(this.getToolbar())) {
            this.closeAllDialogsAndQuickToolbars();
            this.toolbarModule.dropDownModule.closeOpenDropdowns();
            if (this.getToolbarElement().querySelector('.e-rte-dropdown.e-dropdown-btn.e-active')) {
                var targetEle = this.getToolbarElement().querySelector('.e-rte-dropdown.e-dropdown-btn.e-active');
                var hasFontColor = targetEle.classList.contains('e-rte-font-colorpicker');
                if (hasFontColor || targetEle.classList.contains('e-rte-background-colorpicker')) {
                    this.notify(events.showColorPicker, {
                        toolbarClick: hasFontColor ?
                            'fontcolor' : 'backgroundcolor'
                    });
                }
            }
            var focusElement = this.element.querySelector('.e-audio-focus') || this.element.querySelector('.e-video-focus') || this.element.querySelector('.e-img-focus');
            if (focusElement) {
                focusElement.classList.remove('e-audio-focus', 'e-video-focus', 'e-img-focus');
                if (focusElement.style.outline) {
                    focusElement.style.removeProperty('outline');
                }
            }
            var selectedTableCell = this.element.querySelector('.e-cell-select');
            if (selectedTableCell) {
                selectedTableCell.classList.remove('e-cell-select');
            }
            this.inputElement.innerHTML = cleanupInternalElements(this.inputElement.innerHTML, this.editorMode);
            var previewElement = this.getToolbar().querySelector("[id=\"" + this.getID() + "_toolbar_Preview\"]");
            if (previewElement && !previewElement.parentElement.classList.contains('e-overlay')) {
                this.toggleOverlay(previewElement.parentElement, true);
            }
            var maxOrMin = this.getToolbar().querySelector("[id=\"" + this.getID() + "_toolbar_Maximize") || this.getToolbar().querySelector("[id=\"" + this.getID() + "_toolbar_Minimize");
            if (maxOrMin && !maxOrMin.parentElement.classList.contains('e-overlay')) {
                this.toggleOverlay(maxOrMin.parentElement, true);
            }
            this.disableToolbarItem(this.toolbarSettings.items);
            this.disableSplitButtons();
            if (!this.inlineMode.enable && this.toolbarModule && this.toolbarModule.baseToolbar) {
                this.toolbarModule.baseToolbar.toolbarObj.disable(true);
            }
        }
        else if (!this.readonly && this.toolbarSettings.enable && !isNOU(this.getToolbar()) && !initialLoad) {
            var previewElement = this.getToolbar().querySelector("[id=\"" + this.getID() + "_toolbar_Preview\"]");
            if (isNOU(previewElement)) {
                this.enableToolbarItem(this.toolbarSettings.items);
                this.enableSplitButtons();
            }
            else {
                if (previewElement && previewElement.parentElement.classList.contains('e-overlay')) {
                    this.toggleOverlay(previewElement.parentElement, false);
                }
                this.toggleOverlay(previewElement.parentElement, false);
            }
            if (!this.inlineMode.enable && this.toolbarModule && this.toolbarModule.baseToolbar) {
                this.toolbarModule.baseToolbar.toolbarObj.disable(false);
            }
            var maxOrMin = this.getToolbar().querySelector("[id=\"" + this.getID() + "_toolbar_Maximize") || this.getToolbar().querySelector("[id=\"" + this.getID() + "_toolbar_Minimize");
            if (maxOrMin && maxOrMin.parentElement.classList.contains('e-overlay')) {
                this.toggleOverlay(maxOrMin.parentElement, false);
            }
        }
    };
    RichTextEditor.prototype.disableSplitButtons = function () {
        var toolbarElement = this.getToolbarElement();
        if (!toolbarElement) {
            return;
        }
        var splitButtonWrappers = toolbarElement.querySelectorAll('.e-split-btn-wrapper');
        splitButtonWrappers.forEach(function (wrapper) {
            var buttons = wrapper.querySelectorAll('button');
            buttons.forEach(function (button) {
                button.tabIndex = -1;
                button.setAttribute('aria-disabled', 'true');
            });
        });
    };
    RichTextEditor.prototype.enableSplitButtons = function () {
        var toolbarElement = this.getToolbarElement();
        if (!toolbarElement) {
            return;
        }
        var splitButtonWrappers = toolbarElement.querySelectorAll('.e-split-btn-wrapper');
        splitButtonWrappers.forEach(function (wrapper) {
            var buttons = wrapper.querySelectorAll('button');
            buttons.forEach(function (button) {
                button.tabIndex = 0;
                button.setAttribute('aria-disabled', 'false');
            });
        });
    };
    RichTextEditor.prototype.replaceEntities = function (value) {
        var _this = this;
        if (this.editorMode !== 'HTML' || isNOU(value) || !/&(amp;)*((times)|(divide)|(ne))/.test(value)) {
            return value === ' ' ? '<p><br></p>' : value;
        }
        var isEncodedOrSanitized = this.enableHtmlEncode || this.enableHtmlSanitizer;
        var createReplacement = function (entity) {
            var replacement = isEncodedOrSanitized ? "&amp;amp;" + entity : "&amp;" + entity;
            var regexPattern = (!_this.enableHtmlEncode && _this.enableHtmlSanitizer)
                ? "&(" + entity + ")"
                : "&(amp;)*(" + entity + ")";
            var regExp = RegExp;
            var regex = new regExp(regexPattern, 'g');
            return [replacement, regex];
        };
        var entities = ['times', 'divide', 'ne'];
        var replacementsAndRegexes = entities.map(createReplacement);
        for (var _i = 0, replacementsAndRegexes_1 = replacementsAndRegexes; _i < replacementsAndRegexes_1.length; _i++) {
            var _a = replacementsAndRegexes_1[_i], replacement = _a[0], regex = _a[1];
            if (regex.test(value)) {
                value = value.replace(regex, replacement);
            }
        }
        return value;
    };
    RichTextEditor.prototype.updatePanelValue = function () {
        this.setProperties({ value: this.replaceEntities(this.value) }, true);
        var value = this.editorMode === 'HTML' && !isNOU(this.value) ? this.listOrderCorrection(this.value) : this.value;
        value = (this.enableHtmlEncode && this.value) ? decode(value) : value;
        var isInnerHtmlChanged = false;
        var getTextArea = this.element.querySelector('.' + classes.CLS_RTE_SOURCE_CODE_TXTAREA);
        if (value) {
            if (!isNOU(getTextArea) && this.rootContainer.classList.contains('e-source-code-enabled')) {
                getTextArea.value = alignmentHtml(this.value);
            }
            if (this.valueContainer) {
                this.valueContainer.value = (this.enableHtmlEncode) ? this.value : value;
            }
            if (this.editorMode === 'HTML' && this.inputElement && this.inputElement.innerHTML.trim() !== value.trim()) {
                this.inputElement.innerHTML = resetContentEditableElements(value, this.editorMode);
                isInnerHtmlChanged = true;
            }
            else if (this.editorMode === 'Markdown' && this.inputElement
                && this.inputElement.value.trim() !== value.trim()) {
                this.inputElement.value = value;
            }
        }
        else {
            if (!isNOU(getTextArea) && this.rootContainer.classList.contains('e-source-code-enabled')) {
                getTextArea.value = '';
            }
            if (this.editorMode === 'HTML') {
                if (this.enterKey === 'DIV') {
                    this.inputElement.innerHTML = '<div><br/></div>';
                }
                else if (this.enterKey === 'BR') {
                    this.inputElement.innerHTML = '<br/>';
                }
                else {
                    this.inputElement.innerHTML = '<p><br/></p>';
                }
                isInnerHtmlChanged = true;
            }
            else {
                this.inputElement.value = '';
            }
            if (this.valueContainer) {
                this.valueContainer.value = '';
            }
        }
        if (isInnerHtmlChanged && this.editorMode === 'HTML' && getTextArea) {
            this.resetCursorPositionToStart();
        }
        if (this.showCharCount) {
            this.countModule.refresh();
        }
    };
    /**
     * Resets the cursor position to the beginning of the editor content.
     * This method is called when the HTML content within the editor changes,
     * ensuring proper cursor placement at the start of the content.
     *
     * @returns {void}
     * @private
     */
    RichTextEditor.prototype.resetCursorPositionToStart = function () {
        // Skip if source code mode is enabled
        if (this.rootContainer.classList.contains('e-source-code-enabled')) {
            return;
        }
        var editPanel = this.contentModule.getEditPanel();
        var selection = editPanel.ownerDocument.getSelection();
        var range = editPanel.ownerDocument.createRange();
        // Try to position cursor at the first text node
        var firstTextNode = this.formatter.editorManager.domTree.getFirstTextNode(editPanel);
        var targetNode = firstTextNode || editPanel.firstChild;
        if (targetNode) {
            range.setStart(targetNode, 0);
            range.collapse(true);
            selection.removeAllRanges();
            selection.addRange(range);
        }
    };
    RichTextEditor.prototype.listOrderCorrection = function (value) {
        var valueElementWrapper = this.createElement('div');
        valueElementWrapper.innerHTML = value;
        var listElements = valueElementWrapper.querySelectorAll('UL, OL');
        for (var i = 0; i < listElements.length; i++) {
            if (!isNOU(listElements[i]) && !isNOU(listElements[i].parentElement) && !isNOU(listElements[i].previousElementSibling) && (listElements[i].parentElement.nodeName === 'UL' || listElements[i].parentElement.nodeName === 'OL')) {
                listElements[i].previousElementSibling.appendChild(listElements[i]);
            }
        }
        return valueElementWrapper.innerHTML;
    };
    RichTextEditor.prototype.setHeight = function (height) {
        if (height !== 'auto') {
            this.element.style.height = formatUnit(height);
        }
        else {
            this.element.style.height = 'auto';
        }
        if (this.toolbarSettings.type === 'Expand' && (typeof (this.height) === 'string' &&
            this.height.indexOf('px') > -1 || typeof (this.height) === 'number')) {
            this.element.classList.add(classes.CLS_RTE_FIXED_TB_EXPAND);
        }
        else {
            this.element.classList.remove(classes.CLS_RTE_FIXED_TB_EXPAND);
        }
    };
    /**
     * setPlaceHolder method
     *
     * @returns {void}
     * @hidden
     * @deprecated
     */
    RichTextEditor.prototype.setPlaceHolder = function () {
        if (this.inputElement && this.placeholder && this.iframeSettings.enable !== true) {
            if (this.editorMode !== 'Markdown') {
                if (!this.placeHolderWrapper || !this.inputElement.parentElement.contains(this.placeHolderWrapper)) {
                    this.placeHolderWrapper = this.createElement('span', { className: 'e-rte-placeholder' + ' ' + this.getCssClass() });
                    if (this.fontSize.default) {
                        this.placeHolderWrapper.style.fontSize = this.fontSize.default;
                    }
                    if (this.inputElement) {
                        this.inputElement.parentElement.insertBefore(this.placeHolderWrapper, this.inputElement);
                    }
                }
                this.placeHolderWrapper.innerHTML = this.placeholder;
                if (this.inputElement.textContent.length === 0 && this.inputElement.childNodes.length < 2 && !isNOU(this.inputElement.firstChild) && (this.inputElement.firstChild.nodeName === 'BR' ||
                    ((this.inputElement.firstChild.nodeName === 'P' || this.inputElement.firstChild.nodeName === 'DIV') && !isNOU(this.inputElement.firstChild.firstChild) &&
                        this.inputElement.firstChild.childNodes.length < 2 && this.inputElement.firstChild.firstChild.nodeName === 'BR'))) {
                    this.placeHolderWrapper.classList.add('e-placeholder-enabled');
                }
                else {
                    this.placeHolderWrapper.classList.remove('e-placeholder-enabled');
                }
            }
            else {
                this.inputElement.setAttribute('placeholder', this.placeholder);
            }
        }
        if (this.placeholder && this.iframeSettings.enable && this.inputElement) {
            if (this.inputElement.textContent.length === 0 && this.inputElement.childNodes.length < 2 && !isNOU(this.inputElement.firstChild) && (this.inputElement.firstChild.nodeName === 'BR' ||
                ((this.inputElement.firstChild.nodeName === 'P' || this.inputElement.firstChild.nodeName === 'DIV') && !isNOU(this.inputElement.firstChild.firstChild) &&
                    this.inputElement.firstChild.firstChild.nodeName === 'BR'))) {
                addClass([this.inputElement], 'e-rte-placeholder');
                this.inputElement.setAttribute('placeholder', this.placeholder);
            }
            else {
                removeClass([this.inputElement], 'e-rte-placeholder');
            }
        }
    };
    RichTextEditor.prototype.setWidth = function (width) {
        if (width !== 'auto') {
            setStyleAttribute(this.element, { 'width': formatUnit(this.width) });
        }
        else {
            this.element.style.width = 'auto';
        }
    };
    RichTextEditor.prototype.updateCssClass = function (cssClass, setCssClass) {
        if (!isNOU(cssClass)) {
            var allClassName = cssClass.split(' ');
            for (var i = 0; i < allClassName.length; i++) {
                if (allClassName[i].trim() !== '') {
                    if (setCssClass) {
                        // Will set the css class
                        this.element.classList.add(allClassName[i]);
                    }
                    else {
                        // Will remove the css class
                        removeClass([this.element], allClassName[i]);
                    }
                }
            }
        }
    };
    RichTextEditor.prototype.updateRTL = function () {
        this.notify(events.rtlMode, { enableRtl: this.enableRtl });
        if (this.enableRtl) {
            this.element.classList.add(classes.CLS_RTL);
            this.inputElement.classList.add(classes.CLS_RTL);
        }
        else {
            this.element.classList.remove(classes.CLS_RTL);
            this.inputElement.classList.remove(classes.CLS_RTL);
        }
    };
    RichTextEditor.prototype.updateReadOnly = function () {
        this.notify(events.readOnlyMode, { editPanel: this.inputElement, mode: this.readonly });
    };
    /**
     * setReadOnly method
     *
     * @param {boolean} initial - specifies the boolean value
     * @returns {void}
     * @hidden
     * @deprecated
     */
    RichTextEditor.prototype.setReadOnly = function (initial) {
        this.updateReadOnly();
        if (!initial) {
            if (this.readonly && this.enabled) {
                this.unbindEvents();
                this.unWireEvents();
            }
            else if (this.enabled) {
                this.wireEvents();
            }
        }
    };
    /**
     * Prints all the pages of the RichTextEditor by default.
     *
     * @returns {void}
     */
    RichTextEditor.prototype.print = function () {
        var _this = this;
        var printWind;
        var printArgs = {
            element: this.inputElement,
            requestType: 'print',
            cancel: false
        };
        this.trigger(events.actionBegin, printArgs, function (printingArgs) {
            printWind = window.open('', 'print', 'height=' + window.outerHeight + ',width=' + window.outerWidth);
            if (Browser.info.name === 'msie') {
                printWind.resizeTo(screen.availWidth, screen.availHeight);
            }
            if (_this.iframeSettings.enable) {
                printWind = openPrintWindow(_this.inputElement, printWind);
            }
            else {
                var wrapper = document.createElement('div');
                addClass([wrapper], ['e-richtexteditor', 'e-control']);
                var content = document.createElement('div');
                addClass([content], ['e-rte-content']);
                content.appendChild(_this.inputElement.cloneNode(true));
                wrapper.appendChild(content);
                printWind = printWindow(wrapper, printWind);
            }
            if (!printingArgs.cancel) {
                var actionArgs = {
                    requestType: 'print'
                };
                _this.trigger(events.actionComplete, actionArgs);
            }
        });
    };
    /**
     * Refreshes the view of the editor.
     *
     * @returns {void}
     * @public
     */
    RichTextEditor.prototype.refreshUI = function () {
        this.renderModule.refresh();
        // when the editor mode is markdown or iframe, need to set the height manually
        if (this.editorMode === 'Markdown' || this.iframeSettings.enable) {
            this.autoResize();
        }
        if (!isNOU(this.quickToolbarModule) && !this.quickToolbarModule.isDestroyed) {
            this.quickToolbarModule.refreshQuickToolbarPopup(null);
        }
    };
    /**
     * Displays the Rich Text Editor component in full-screen mode.
     *
     * @returns {void}
     */
    RichTextEditor.prototype.showFullScreen = function () {
        this.fullScreenModule.showFullScreen();
    };
    /**
     * Enables the specified toolbar items in the Rich Text Editor component.
     *
     * @param {string | string[]} items - A single item or a collection of items to be enabled in the toolbar.
     * @param {boolean} muteToolbarUpdate - Determines whether to mute updates of the toolbar item status in the Rich Text Editor.
     * @returns {void}
     * @public
     */
    RichTextEditor.prototype.enableToolbarItem = function (items, muteToolbarUpdate) {
        this.toolbarModule.enableTBarItems(this.getBaseToolbarObject(), items, true, muteToolbarUpdate);
    };
    /**
     * Disables the specified toolbar items in the Rich Text Editor component.
     *
     * @param {string | string[]} items - A single item or a collection of items to be disabled in the toolbar.
     * @param {boolean} muteToolbarUpdate - Determines whether to mute updates of the toolbar item status in the Rich Text Editor.
     * @returns {void}
     * @public
     */
    RichTextEditor.prototype.disableToolbarItem = function (items, muteToolbarUpdate) {
        this.toolbarModule.enableTBarItems(this.getBaseToolbarObject(), items, false, muteToolbarUpdate);
    };
    /**
     * Removes the specified toolbar items from the Rich Text Editor component.
     *
     * @param {string | string[]} items - A single item or a collection of items to be removed from the toolbar.
     * @returns {void}
     * @public
     */
    RichTextEditor.prototype.removeToolbarItem = function (items) {
        this.toolbarModule.removeTBarItems(items);
    };
    /**
     * Get the selected range from the RichTextEditor's content.
     *
     * @returns {void}
     * @public
     * @deprecated
     */
    RichTextEditor.prototype.getRange = function () {
        return this.formatter.editorManager.nodeSelection.getRange(this.contentModule.getDocument());
    };
    RichTextEditor.prototype.initializeServices = function () {
        this.serviceLocator.register('rendererFactory', new RendererFactory);
        this.serviceLocator.register('rteLocale', this.localeObj = new L10n(this.getModuleName(), defaultLocale, this.locale));
        this.serviceLocator.register('dialogRenderObject', new DialogRenderer(this));
        this.serviceLocator.register('popupUploaderObject', new PopupUploader(this));
    };
    RichTextEditor.prototype.RTERender = function () {
        var rendererFactory = this.serviceLocator.getService('rendererFactory');
        this.contentModule = rendererFactory.getRenderer(RenderType.Content);
        this.fullScreenModule = new FullScreen(this);
        this.renderModule.render();
        this.inputElement = this.contentModule.getEditPanel();
        this.setHeight(this.height);
        setAttributes(this.htmlAttributes, this, false, true);
        if (this.iframeSettings) {
            this.setIframeSettings();
        }
        this.updateCssClass(this.cssClass, true);
        this.updateEnable();
        this.setPlaceHolder();
        this.updateRTL();
        this.updateReadOnly();
        this.updatePanelValue();
        if (this.inputElement) {
            this.inputElement.innerHTML = resetContentEditableElements(this.inputElement.innerHTML, this.editorMode);
        }
        if (this.enableHtmlEncode && !isNOU(this.value)) {
            this.setProperties({ value: this.encode(decode(this.value)) });
        }
        this.setIsModalDialogValue();
    };
    RichTextEditor.prototype.setIsModalDialogValue = function () {
        if (this.isAngular && !isNOU(this.inputElement.closest('.cdk-overlay-pane'))) {
            this.isModalDialog = true;
        }
    };
    RichTextEditor.prototype.setIframeSettings = function () {
        if (this.iframeSettings.resources) {
            var styleSrc = this.iframeSettings.resources.styles;
            var scriptSrc = this.iframeSettings.resources.scripts;
            if (!isNOU(this.iframeSettings.resources.scripts) && this.iframeSettings.resources.scripts.length > 0) {
                this.InjectSheet(true, scriptSrc);
            }
            if (!isNOU(this.iframeSettings.resources.styles) && this.iframeSettings.resources.styles.length > 0) {
                this.InjectSheet(false, styleSrc);
            }
        }
        if (this.iframeSettings.attributes) {
            setAttributes(this.iframeSettings.attributes, this, true, false);
        }
    };
    RichTextEditor.prototype.InjectSheet = function (scriptSheet, srcList) {
        try {
            if (srcList && srcList.length > 0) {
                var iFrame = this.contentModule.getDocument();
                var target = iFrame.querySelector('head');
                for (var i = 0; i < srcList.length; i++) {
                    if (scriptSheet) {
                        var scriptEle = this.createScriptElement();
                        scriptEle.src = srcList[i];
                        target.appendChild(scriptEle);
                    }
                    else {
                        var styleEle = this.createStyleElement();
                        styleEle.href = srcList[i];
                        target.appendChild(styleEle);
                    }
                }
            }
        }
        catch (e) {
            return;
        }
    };
    RichTextEditor.prototype.createScriptElement = function () {
        var scriptEle = this.createElement('script', {
            className: classes.CLS_SCRIPT_SHEET
        });
        scriptEle.type = 'text/javascript';
        return scriptEle;
    };
    RichTextEditor.prototype.createStyleElement = function () {
        var styleEle = this.createElement('link', {
            className: classes.CLS_STYLE_SHEET
        });
        styleEle.rel = 'stylesheet';
        return styleEle;
    };
    RichTextEditor.prototype.setValue = function (isPropertyChange) {
        var _this = this;
        if (this.valueTemplate) {
            var regEx = new RegExp(/<(?=.*? .*?\/ ?>|br|hr|input|!--|wbr)[a-z]+.*?>|<([a-z]+).*?<\/\1>/i);
            if (typeof this.valueTemplate === 'string' && regEx.test(this.valueTemplate)) {
                this.setProperties({ value: this.valueTemplate });
            }
            else {
                var compiledTemplate = compile(this.valueTemplate)('', this, 'valueTemplate');
                if (typeof this.valueTemplate !== 'string' && this.isReact) {
                    this.displayTempElem = this.createElement('div');
                    for (var i = 0; i < compiledTemplate.length; i++) {
                        var item = compiledTemplate[i];
                        append([item], this.displayTempElem);
                    }
                    this.renderTemplates(function () {
                        _this.inputElement.innerHTML = resetContentEditableElements(_this.displayTempElem.childNodes[0].innerHTML, _this.editorMode);
                        _this.setProperties({ value: _this.inputElement.innerHTML.trim() });
                    });
                }
                else {
                    var appendElem = this.element;
                    if (isPropertyChange) {
                        this.inputElement.innerHTML = '';
                        appendElem = this.inputElement;
                    }
                    for (var i = 0; i < compiledTemplate.length; i++) {
                        var item = compiledTemplate[i];
                        append([item], appendElem);
                    }
                    var content = appendElem.innerHTML.trim();
                    if (content.length > 0) {
                        this.setProperties({ value: content });
                    }
                    this.renderReactTemplates();
                }
            }
        }
        else {
            // eslint-disable-next-line
            var innerHtml = !isNOU(this.element.innerHTML) && this.element.innerHTML.replace(/<(\/?|\!?)(!--!--)>/g, '').trim();
            if (innerHtml !== '') {
                if (this.element.tagName === 'TEXTAREA') {
                    this.setProperties({ value: decode(innerHtml) });
                }
                else {
                    this.setProperties({ value: innerHtml });
                }
            }
        }
    };
    // eslint-disable-next-line
    RichTextEditor.prototype.renderTemplates = function (callBack) {
        this.renderReactTemplates(callBack);
    };
    RichTextEditor.prototype.updateResizeFlag = function () {
        this.isResizeInitialized = true;
    };
    /**
     * Image max width calculation method
     *
     * @returns {void}
     * @hidden
     * @deprecated
     */
    RichTextEditor.prototype.getInsertImgMaxWidth = function () {
        var maxWidth = this.insertImageSettings.maxWidth;
        // eslint-disable-next-line
        var imgPadding = 12;
        var imgResizeBorder = 2;
        var editEle = this.contentModule.getEditPanel();
        if (this.editorMode === 'HTML' && !isNOU(this.formatter.editorManager.nodeSelection) && !isNOU(this.formatter.editorManager.nodeSelection.range)) {
            var currentRange = this.formatter.editorManager.nodeSelection.range;
            if (currentRange.startContainer.nodeType !== 3 && currentRange.startContainer.closest &&
                !isNOU(currentRange.startContainer.closest('TD'))) {
                editEle = currentRange.startContainer;
            }
        }
        var eleStyle = window.getComputedStyle(editEle);
        var editEleMaxWidth = editEle.offsetWidth - (imgPadding + imgResizeBorder +
            parseFloat(eleStyle.paddingLeft.split('px')[0]) + parseFloat(eleStyle.paddingRight.split('px')[0]) +
            parseFloat(eleStyle.marginLeft.split('px')[0]) + parseFloat(eleStyle.marginRight.split('px')[0]));
        return isNOU(maxWidth) ? editEleMaxWidth : maxWidth;
    };
    /**
     * Video max width calculation method
     *
     * @returns {void}
     * @hidden
     * @deprecated
     */
    RichTextEditor.prototype.getInsertVidMaxWidth = function () {
        var maxWidth = this.insertVideoSettings.maxWidth;
        // eslint-disable-next-line
        var vidPadding = 12;
        var vidResizeBorder = 2;
        var editEle = this.contentModule.getEditPanel();
        var eleStyle = window.getComputedStyle(editEle);
        var editEleMaxWidth = editEle.offsetWidth - (vidPadding + vidResizeBorder +
            parseFloat(eleStyle.paddingLeft.split('px')[0]) + parseFloat(eleStyle.paddingRight.split('px')[0]) +
            parseFloat(eleStyle.marginLeft.split('px')[0]) + parseFloat(eleStyle.marginRight.split('px')[0]));
        return isNOU(maxWidth) ? editEleMaxWidth : maxWidth;
    };
    /**
     * Retrieves the HTML content from the Rich Text Editor.
     *
     * @returns {string} - The HTML content as a string. If XHTML is enabled, `null` is returned for empty content.
     * @public
     */
    RichTextEditor.prototype.getHtml = function () {
        var htmlValue = cleanupInternalElements(this.contentModule.getEditPanel().innerHTML, this.editorMode);
        return (this.enableXhtml && (htmlValue === '<p><br></p>' || htmlValue === '<div><br></div>' ||
            htmlValue === '<br>') ? null : this.serializeValue(htmlValue));
    };
    /**
     * Retrieves XHTML validated HTML content from the Rich Text Editor
     * when the `enableXhtml` property is set to true.
     *
     * @returns {string} - The XHTML validated HTML content as a string.
     * @public
     */
    RichTextEditor.prototype.getXhtml = function () {
        var currentValue = cleanupInternalElements(this.value, this.editorMode);
        if (!isNOU(currentValue) && this.enableXhtml) {
            currentValue = this.htmlEditorModule.xhtmlValidation.selfEncloseValidation(currentValue);
        }
        return currentValue;
    };
    /**
     * Toggles the display of the HTML/Markdown source code within the editor.
     *
     * @returns {void}
     * @public
     */
    RichTextEditor.prototype.showSourceCode = function () {
        if (this.readonly) {
            return;
        }
        var preview = this.element.querySelector('.e-rte-container.e-source-code-enabled');
        if (preview) {
            this.notify(events.updateSource, {});
        }
        else {
            this.notify(events.sourceCode, {});
        }
    };
    /**
     * Calculates the maximum number of characters currently in the Rich Text Editor.
     *
     * @returns {number} - The total number of characters.
     * @public
     */
    RichTextEditor.prototype.getCharCount = function () {
        var htmlText = this.editorMode === 'Markdown' ? this.inputElement.value.trim() :
            this.inputElement.textContent.trim();
        var htmlLength;
        if (this.editorMode !== 'Markdown' && htmlText.indexOf('\u200B') !== -1) {
            htmlLength = htmlText.replace(/\u200B/g, '').length;
        }
        else {
            htmlLength = htmlText.length;
        }
        return htmlLength;
    };
    /**
     * Displays a specified dialog within the Rich Text Editor.
     *
     * @param {DialogType} type - The type of dialog to display.
     * @returns {void}
     * @public
     */
    RichTextEditor.prototype.showDialog = function (type) {
        if (type === DialogType.InsertLink) {
            this.notify(events.showLinkDialog, {});
        }
        else if (type === DialogType.InsertImage) {
            this.notify(events.showImageDialog, {});
        }
        else if (type === DialogType.InsertAudio) {
            this.notify(events.showAudioDialog, {});
        }
        else if (type === DialogType.InsertVideo) {
            this.notify(events.showVideoDialog, {});
        }
        else if (type === DialogType.InsertTable) {
            this.notify(events.showTableDialog, {});
        }
    };
    /**
     * Closes a specified dialog within the Rich Text Editor.
     *
     * @param {DialogType} type - The type of dialog to close.
     * @returns {void}
     * @public
     */
    RichTextEditor.prototype.closeDialog = function (type) {
        if (type === DialogType.InsertLink) {
            this.notify(events.closeLinkDialog, {});
        }
        else if (type === DialogType.InsertImage) {
            this.notify(events.closeImageDialog, {});
        }
        else if (type === DialogType.InsertAudio) {
            this.notify(events.closeAudioDialog, {});
        }
        else if (type === DialogType.InsertVideo) {
            this.notify(events.closeVideoDialog, {});
        }
        else if (type === DialogType.InsertTable) {
            this.notify(events.closeTableDialog, {});
        }
    };
    /**
     * @returns {void}
     * @hidden
     * @deprecated
     */
    RichTextEditor.prototype.getBaseToolbarObject = function () {
        var tbObj;
        if (this.inlineMode.enable && (!Browser.isDevice || isIDevice())) {
            tbObj = this.quickToolbarModule && this.quickToolbarModule.getInlineBaseToolbar();
        }
        else {
            tbObj = this.toolbarModule && this.toolbarModule.getBaseToolbar();
        }
        return tbObj;
    };
    /**
     * @returns {void}
     * @hidden
     * @deprecated
     */
    RichTextEditor.prototype.getToolbar = function () {
        return this.toolbarModule ? this.toolbarModule.getToolbarElement() : null;
    };
    /**
     * @returns {void}
     * @hidden
     * @deprecated
     */
    RichTextEditor.prototype.getToolbarElement = function () {
        return this.toolbarModule && this.toolbarModule.getToolbarElement();
    };
    /**
     * @returns {void}
     * getID method
     *
     * @hidden
     * @deprecated
     */
    RichTextEditor.prototype.getID = function () {
        return this.internalID;
    };
    /**
     * Returns the CSS class.
     *
     * @param {boolean} [isSpace] - Specifies whether to include a space before the CSS class.
     * @returns {string} The CSS class.
     * @hidden
     * @deprecated
     */
    RichTextEditor.prototype.getCssClass = function (isSpace) {
        return (isNOU(this.cssClass) ? '' : isSpace ? ' ' + this.cssClass : this.cssClass);
    };
    RichTextEditor.prototype.mouseDownHandler = function (e) {
        this.isSelectionStartInRTE = true;
        this.resetPreviousKey();
        var touch = (e.touches ? e.changedTouches[0] : e);
        addClass([this.element], [classes.CLS_FOCUS]);
        this.preventDefaultResize(e);
        this.notify(events.mouseDown, { args: e });
        this.formatter.editorManager.observer.notify(events.mouseDown, { args: e });
        this.clickPoints = { clientX: touch.clientX, clientY: touch.clientY };
        this.notify(EVENTS.touchStart, e);
    };
    RichTextEditor.prototype.preventImgResize = function (e) {
        if (e.target.nodeName.toLocaleLowerCase() === 'img') {
            e.preventDefault();
        }
    };
    /**
     * preventDefaultResize method
     *
     * @param {FocusEvent} e - specifies the event.
     * @returns {void}
     * @hidden
     * @deprecated
     */
    // eslint-disable-next-line
    RichTextEditor.prototype.preventDefaultResize = function (e) {
        if (Browser.info.name === 'msie') {
            this.contentModule.getEditPanel().addEventListener('mscontrolselect', this.preventImgResize);
        }
        else if (Browser.info.name === 'mozilla') {
            this.contentModule.getDocument().execCommand('enableObjectResizing', false, 'false');
            this.contentModule.getDocument().execCommand('enableInlineTableEditing', false, 'false');
        }
    };
    // eslint-disable-next-line
    RichTextEditor.prototype.defaultResize = function (e) {
        if (Browser.info.name === 'msie') {
            this.contentModule.getEditPanel().removeEventListener('mscontrolselect', this.preventImgResize);
        }
        else if (Browser.info.name === 'mozilla') {
            this.contentModule.getDocument().execCommand('enableObjectResizing', true, 'true');
            this.contentModule.getDocument().execCommand('enableInlineTableEditing', true, 'true');
        }
    };
    RichTextEditor.prototype.resizeHandler = function (e) {
        if (!document.body.contains(this.element)) {
            document.defaultView.removeEventListener('resize', this.resizeHandler, true);
            this.onResizeHandler = null;
            return;
        }
        if (this.toolbarSettings.enable && !this.inlineMode.enable) {
            this.toolbarModule.refreshToolbarOverflow();
        }
        this.notify(events.windowResize, { args: e });
        this.autoResize();
    };
    RichTextEditor.prototype.scrollHandler = function (e) {
        if (this.element) {
            this.notify(events.scroll, { args: e });
        }
    };
    RichTextEditor.prototype.contentScrollHandler = function (e) {
        this.notify(events.contentscroll, { args: e });
    };
    RichTextEditor.prototype.focusHandler = function (e) {
        var target = e.target;
        if (!this.isRTE || this.isFocusOut) {
            this.updateFocusState(target);
            this.setCloneValue();
            this.handleInternalFocus(target);
            this.preventDefaultResize(e);
            this.trigger('focus', { event: e, isInteracted: Object.keys(e).length !== 0 });
            this.initSaveInterval();
            EventHandler.add(document, 'mousedown', this.onDocumentClick, this);
        }
        this.resetToolbarOnFocus(e);
    };
    RichTextEditor.prototype.updateFocusState = function (target) {
        this.isRTE = !this.isFocusOut;
        this.isFocusOut = false;
        if (target && target.nodeName !== '#text' && target.closest('.e-content')) {
            this.isRTEFocused = true;
        }
        addClass([this.element], [classes.CLS_FOCUS]);
    };
    RichTextEditor.prototype.setCloneValue = function () {
        if (this.editorMode === 'HTML') {
            var rteContent = this.inputElement.innerHTML;
            this.cloneValue = (rteContent === '<p><br></p>' || rteContent === '<div><br></div>' || rteContent === '<br>') ? null :
                (this.enableHtmlEncode ? this.encode(decode(rteContent)) : rteContent);
        }
        else {
            this.cloneValue = this.inputElement.value === '' ? null : this.inputElement.value;
        }
    };
    RichTextEditor.prototype.handleInternalFocus = function (target) {
        var active = document.activeElement;
        var isRTEFocusedOnTBClick;
        var toolbarElement = this.getToolbarElement();
        var isIframePanel = this.iframeSettings.enable && active === this.contentModule.getPanel();
        var isImageCaption = target && (target.classList.contains('e-img-caption-text') || (target.parentElement && target.parentElement.classList.contains('e-img-wrap')));
        if (active === this.element || active === toolbarElement || active === this.contentModule.getEditPanel() ||
            (isIframePanel && target && !isImageCaption) || (!isNOU(toolbarElement) && closest(active, '.e-rte-toolbar') === toolbarElement)) {
            if ((active.closest('.e-ai-commands-tbar-btn') || active.closest('.e-progress-btn')) && !this.inputElement.contains(this.getRange().startContainer)) {
                isRTEFocusedOnTBClick = true;
            }
            if (!isRTEFocusedOnTBClick) {
                this.contentModule.getEditPanel().focus();
            }
            if (!isNOU(toolbarElement)) {
                toolbarElement.setAttribute('tabindex', '-1');
                var items = toolbarElement.querySelectorAll('[tabindex="0"]');
                for (var i = 0; i < items.length; i++) {
                    items[i].setAttribute('tabindex', '-1');
                }
            }
        }
    };
    RichTextEditor.prototype.initSaveInterval = function () {
        if (!isNOU(this.saveInterval) && this.saveInterval > 0 && !this.autoSaveOnIdle && isNOU(this.timeInterval) && this.editorMode === 'Markdown') {
            this.timeInterval = setInterval(this.updateValueOnIdle.bind(this), this.saveInterval);
        }
    };
    RichTextEditor.prototype.resetToolbarOnFocus = function (e) {
        if (!this.readonly) {
            var currentFocus = this.getCurrentFocus(e);
            if (currentFocus === 'editArea' || currentFocus === 'textArea' || currentFocus === 'sourceCode') {
                this.resetToolbarTabIndex();
            }
        }
    };
    RichTextEditor.prototype.getUpdatedValue = function () {
        var value;
        var getTextArea = this.element.querySelector('.' + classes.CLS_RTE_SOURCE_CODE_TXTAREA);
        if (this.editorMode === 'HTML') {
            value = (this.inputElement.innerHTML === '<p><br></p>' || this.inputElement.innerHTML === '<div><br></div>' ||
                this.inputElement.innerHTML === '<br>') ? null : this.enableHtmlEncode ?
                this.encode(decode(cleanupInternalElements(this.inputElement.innerHTML, this.editorMode))) :
                this.inputElement.innerHTML;
            if (this.enableHtmlSanitizer && !isNOU(value) && /&(amp;)*((times)|(divide)|(ne))/.test(value)) {
                value = value.replace(/&(amp;)*(times|divide|ne)/g, '&amp;amp;$2');
            }
            if (!isNOU(getTextArea) && this.rootContainer.classList.contains('e-source-code-enabled')) {
                var textAreaValue = this.enableHtmlSanitizer ? this.htmlEditorModule.sanitizeHelper(getTextArea.value) : getTextArea.value;
                value = cleanHTMLString((/&(amp;)*((times)|(divide)|(ne))/.test(textAreaValue) ? textAreaValue.replace(/&(amp;)*(times|divide|ne)/g, '&amp;amp;$2') : textAreaValue), this.element);
            }
        }
        else {
            value = this.inputElement.value === '' ? null :
                this.inputElement.value;
        }
        if (value != null && !this.enableHtmlEncode) {
            value = cleanupInternalElements(value, this.editorMode);
        }
        return value;
    };
    RichTextEditor.prototype.updateValueOnIdle = function () {
        if (!isNOU(this.tableModule) && !isNOU(this.inputElement.querySelector('.e-table-box.e-rbox-select'))) {
            return;
        }
        if (!this.rootContainer.classList.contains('e-source-code-enabled')) {
            this.setProperties({ value: this.getUpdatedValue() }, true);
        }
        else {
            this.setProperties({ value: this.getUpdatedValue() });
        }
        this.valueContainer.value = this.value;
        this.isValueChangeBlurhandler = false;
        this.invokeChangeEvent();
    };
    RichTextEditor.prototype.updateIntervalValue = function () {
        clearTimeout(this.idleInterval);
        this.idleInterval = setTimeout(this.updateValueOnIdle.bind(this), 0);
    };
    RichTextEditor.prototype.cleanupResizeElements = function (args) {
        var value = cleanupInternalElements(args.value, this.editorMode);
        args.callBack(value);
    };
    RichTextEditor.prototype.addAnchorAriaLabel = function (value) {
        var valueElementWrapper = document.createElement('div');
        valueElementWrapper.innerHTML = value;
        var item = valueElementWrapper.querySelectorAll('a');
        if (item.length > 0) {
            for (var i = 0; i < item.length; i++) {
                if (item[i].hasAttribute('target') && item[i].getAttribute('target') === '_blank') {
                    if (!item[i].hasAttribute('aria-label') || item[i].getAttribute('aria-label') === '') {
                        item[i].setAttribute('aria-label', this.serviceLocator.getService('rteLocale').getConstant('linkAriaLabel'));
                    }
                }
            }
        }
        return valueElementWrapper.innerHTML;
    };
    RichTextEditor.prototype.updateStatus = function (e) {
        if (!isNOU(e.html) || !isNOU(e.markdown)) {
            var status_1 = this.formatter.editorManager.undoRedoManager.getUndoStatus();
            var eventArgs = {
                undo: status_1.undo,
                redo: status_1.redo,
                html: e.html,
                markdown: e.markdown
            };
            this.trigger(events.updatedToolbarStatus, eventArgs);
        }
    };
    RichTextEditor.prototype.onDocumentClick = function (e) {
        var target = e.target;
        var rteElement = closest(target, '.' + classes.CLS_RTE);
        if (!this.element.contains(e.target) && document !== e.target && rteElement !== this.element &&
            !closest(target, '[aria-owns="' + this.getID() + '"]')) {
            this.isBlur = true;
            this.isRTE = false;
        }
        this.notify(events.docClick, { args: e });
        this.removeHrFocus(e);
        var hideQuickToolbarChecker = this.quickToolbarModule && !this.inlineMode.enable &&
            isNOU(this.quickToolbarModule.inlineQTBar);
        if ((hideQuickToolbarChecker && !isNOU(closest(target, '.' + 'e-toolbar-wrapper'))) || (hideQuickToolbarChecker && (!isNOU(closest(target, '.e-rte-table-resize')) || !isNOU(closest(target, '.e-table-box'))))) {
            this.quickToolbarModule.hideQuickToolbars();
        }
        if (Browser.info.name !== 'msie' && e.detail > 3) {
            e.preventDefault();
        }
        this.handleChecklistDocumentClick(e, target);
    };
    RichTextEditor.prototype.handleChecklistDocumentClick = function (e, target) {
        if (this.handleChecklistClick(e, target)) {
            var item = this.createToolbarCommand();
            var actionBeginArgs = {
                originalEvent: e,
                item: item
            };
            var currentAction = 'toggleChecklist';
            this.formatter.process(this, actionBeginArgs, e, { action: currentAction });
        }
    };
    RichTextEditor.prototype.createToolbarCommand = function () {
        var item = null;
        if (isNOU(item)) {
            item = {
                command: 'Checklist',
                subCommand: 'Checklist'
            };
        }
        return item;
    };
    RichTextEditor.prototype.handleChecklistClick = function (event, target) {
        if (target.tagName !== 'LI' || !closest(target, '.' + 'e-rte-checklist')) {
            return false;
        }
        var rect = target.getBoundingClientRect();
        var clickX = event.clientX;
        if (this.enableRtl) {
            if (clickX <= rect.right) {
                return false;
            }
        }
        else {
            if (clickX >= rect.left) {
                return false;
            }
        }
        return true;
    };
    RichTextEditor.prototype.blurHandler = function (e) {
        var trg = e.relatedTarget;
        if (trg) {
            var rteElement = closest(trg, '.' + classes.CLS_RTE);
            if (!rteElement && this.iframeSettings.enable) {
                var iframeElement = this.element.querySelector('#' + this.getID() + '_rte-view');
                if (iframeElement && iframeElement.contentWindow.document.body.contains(trg)) {
                    rteElement = closest(iframeElement, '.' + classes.CLS_RTE);
                }
            }
            if (rteElement && rteElement === this.element) {
                this.isBlur = false;
                if (trg === this.getToolbarElement()) {
                    trg.setAttribute('tabindex', '-1');
                }
            }
            else if (closest(trg, '[aria-owns="' + this.getID() + '"]') || closest(trg, '.' + classes.CLS_RTE_ELEMENTS)) {
                this.isBlur = false;
            }
            else {
                this.isBlur = true;
                trg = null;
            }
        }
        if (this.isBlur && isNOU(trg)) {
            removeClass([this.element], [classes.CLS_FOCUS]);
            removeSelectionClassStates(this.inputElement);
            this.notify(events.focusChange, {});
            var value = this.getUpdatedValue();
            if (!this.rootContainer.classList.contains('e-source-code-enabled')) {
                this.setProperties({ value: value }, true);
            }
            else {
                this.setProperties({ value: value });
            }
            this.valueContainer.value = this.value;
            this.isValueChangeBlurhandler = true;
            this.invokeChangeEvent();
            this.isFocusOut = true;
            this.isBlur = false;
            dispatchEvent(this.valueContainer, 'focusout');
            this.defaultResize(e);
            this.trigger('blur', { event: e, isInteracted: Object.keys(e).length === 0 ? false : true });
            if (!isNOU(this.timeInterval)) {
                clearInterval(this.timeInterval);
                this.timeInterval = null;
            }
            if (!isNOU(this.placeHolderWrapper) && this.element.querySelector('[title = Preview]')) {
                this.placeHolderWrapper.style.display = 'none';
            }
            this.isRTEFocused = false;
            EventHandler.remove(document, 'mousedown', this.onDocumentClick);
        }
        else {
            this.isRTE = true;
        }
        if (!this.readonly && this.getCurrentFocus(e) === 'outside') {
            this.resetToolbarTabIndex();
        }
        this.previousRange = null;
    };
    /**
     * invokeChangeEvent method
     *
     * @returns {void}
     * @param {CustomEvent} args - The arguments associated with the content change event.
     * @hidden
     * @deprecated
     */
    RichTextEditor.prototype.contentChanged = function (args) {
        var tempSpanToRemove = this.inputElement.querySelector('.tempSpan');
        if (tempSpanToRemove) {
            detach(tempSpanToRemove);
        }
        if (args && !isNOU(args.detail) && args.detail.click) {
            this.formatter.saveData();
        }
        if (this.autoSaveOnIdle) {
            if (!isNOU(this.saveInterval)) {
                clearTimeout(this.autoSaveTimeOut);
                this.autoSaveTimeOut = setTimeout(this.updateIntervalValue.bind(this), this.saveInterval);
            }
        }
    };
    /**
     * invokeChangeEvent method
     *
     * @returns {void}
     * @hidden
     * @deprecated
     */
    RichTextEditor.prototype.invokeChangeEvent = function () {
        var currentValue;
        if (this.enableXhtml) {
            currentValue = this.getXhtml();
        }
        else {
            currentValue = this.value;
        }
        var eventArgs = {
            value: currentValue,
            isInteracted: this.isValueChangeBlurhandler
        };
        if (this.value !== cleanupInternalElements(this.cloneValue, this.editorMode)) {
            this.trigger('change', eventArgs);
            this.cloneValue = this.value;
        }
    };
    /**
     * @returns {void}
     * @hidden
     * @deprecated
     */
    RichTextEditor.prototype.wireScrollElementsEvents = function () {
        this.scrollParentElements = getScrollableParent(this.element);
        for (var _i = 0, _a = this.scrollParentElements; _i < _a.length; _i++) {
            var element = _a[_i];
            EventHandler.add(element, 'scroll', this.scrollHandler, this);
        }
        if (!this.iframeSettings.enable) {
            // Add the scroll event handler from the inputElement
            EventHandler.add(this.inputElement, 'scroll', this.contentScrollHandler, this);
        }
    };
    RichTextEditor.prototype.wireContextEvent = function () {
        if (this.quickToolbarSettings.showOnRightClick) {
            EventHandler.add(this.inputElement, 'contextmenu', this.contextHandler, this);
            if (Browser.isDevice) {
                this.touchModule = new EJ2Touch(this.inputElement, { tapHold: this.touchHandler.bind(this), tapHoldThreshold: 500 });
            }
        }
    };
    RichTextEditor.prototype.unWireContextEvent = function () {
        EventHandler.remove(this.inputElement, 'contextmenu', this.contextHandler);
        if (Browser.isDevice && this.touchModule) {
            this.touchModule.destroy();
        }
    };
    /**
     * @returns {void}
     * @hidden
     * @deprecated
     */
    RichTextEditor.prototype.unWireScrollElementsEvents = function () {
        this.scrollParentElements = getScrollableParent(this.element);
        for (var _i = 0, _a = this.scrollParentElements; _i < _a.length; _i++) {
            var element = _a[_i];
            EventHandler.remove(element, 'scroll', this.scrollHandler);
        }
        if (!this.iframeSettings.enable) {
            // Remove the scroll event handler from the inputElement
            EventHandler.remove(this.inputElement, 'scroll', this.contentScrollHandler);
        }
    };
    RichTextEditor.prototype.touchHandler = function (e) {
        this.notifyMouseUp(e.originalEvent);
        this.triggerEditArea(e.originalEvent);
    };
    RichTextEditor.prototype.contextHandler = function (e) {
        var closestElem = closest(e.target, 'a, table, img, video, audio, .e-embed-video-wrap');
        if (!closestElem && e.target && e.target.classList &&
            (e.target.classList.contains(classes.CLS_AUDIOWRAP) ||
                e.target.classList.contains(classes.CLS_CLICKELEM))) {
            closestElem = e.target.querySelector('audio');
        }
        if (this.inlineMode.onSelection === false || (!isNOU(closestElem) && this.inputElement.contains(closestElem)
            && (closestElem.tagName === 'IMG' || closestElem.tagName === 'TABLE' || closestElem.tagName === 'A' ||
                closestElem.tagName.toLowerCase() === 'video' || closestElem.tagName.toLowerCase() === 'audio' || closestElem.tagName === 'SPAN'))) {
            e.preventDefault();
        }
    };
    RichTextEditor.prototype.resetHandler = function () {
        var defaultValue = this.valueContainer.defaultValue.trim();
        this.setProperties({ value: defaultValue === '' ? null : defaultValue });
    };
    /**
     * @returns {void}
     * @hidden
     * @deprecated
     */
    RichTextEditor.prototype.autoResize = function () {
        if (!this.element || !this.originalElement || !this.valueContainer) {
            return;
        }
        if (this.height === 'auto') {
            if (this.editorMode === 'Markdown') {
                this.setAutoHeight(this.inputElement);
            }
            else if (this.iframeSettings.enable) {
                var iframeElement = this.element.querySelector('#' + this.getID() + '_rte-view');
                if (iframeElement) {
                    this.setAutoHeight(iframeElement);
                }
            }
        }
        else {
            if (this.editorMode === 'Markdown') {
                var textArea = this.inputElement;
                var otherElemHeight = (this.enableResize || this.showCharCount) ? 20 : 0;
                var toolbarHeight = this.toolbarModule ? this.toolbarModule.getToolbarHeight() : 0;
                // Three added because of border top of the e-rte-container, bottom of the toolbar wrapper and then bottom of the e-rte-container.
                if (textArea) {
                    textArea.style.height = this.element.clientHeight - (toolbarHeight + otherElemHeight + 3) + 'px';
                }
            }
            else if (this.iframeSettings.enable) {
                var iframe = this.element.querySelector('#' + this.getID() + '_rte-view');
                var otherElemHeight = (this.enableResize || this.showCharCount) ? 20 : 0;
                var toolbarHeight = this.toolbarModule ? this.toolbarModule.getToolbarHeight() : 0;
                // Three added because of border top of the e-rte-container, bottom of the toolbar wrapper and then bottom of the e-rte-container.
                if (iframe && this.toolbarModule) {
                    iframe.style.height = this.element.clientHeight - (toolbarHeight + otherElemHeight + 3) + 'px';
                }
            }
        }
    };
    RichTextEditor.prototype.setAutoHeight = function (element) {
        if (element.nodeName === 'TEXTAREA') {
            element.style.height = 'auto';
            element.style.height = (this.inputElement.scrollHeight + 16) + 'px';
            element.style.overflow = 'hidden';
        }
        else if (element.nodeName === 'IFRAME') {
            element.style.height = this.inputElement.parentElement.offsetHeight + 'px';
        }
    };
    RichTextEditor.prototype.checkContentChanged = function (mutations) {
        var _this = this;
        return mutations.some(function (mutation) {
            // Check for text content changes
            if (mutation.type === 'characterData') {
                return true;
            }
            // Check for added or removed nodes
            if (mutation.type === 'childList' &&
                (mutation.addedNodes.length > 0 || mutation.removedNodes.length > 0)) {
                return true;
            }
            // Check for relevant attribute changes (if needed)
            if (mutation.type === 'attributes') {
                var target = mutation.target;
                if (target.isContentEditable && _this.inputElement === target) {
                    return false;
                }
                var attributeName = mutation.attributeName;
                var currentValue = target.getAttribute(attributeName);
                var previousValue = mutation.oldValue;
                return previousValue !== currentValue;
            }
            return false;
        });
    };
    RichTextEditor.prototype.wireEvents = function () {
        var _this = this;
        this.onBlurHandler = this.blurHandler.bind(this);
        this.onFocusHandler = this.focusHandler.bind(this);
        this.onResizeHandler = this.resizeHandler.bind(this);
        this.element.addEventListener('focusin', this.onFocusHandler, true);
        this.element.addEventListener('focusout', this.onBlurHandler, true);
        if (this.editorMode === 'HTML') {
            this.mutationObserver = new MutationObserver(function (mutations) {
                if (mutations.length > 0 && !_this.isFocusOut) {
                    if (_this.checkContentChanged(mutations)) {
                        _this.hasContentChanged = true;
                        // Only set up interval for non-autoSaveOnIdle mode
                        if (!_this.autoSaveOnIdle && !isNOU(_this.saveInterval) && _this.saveInterval > 0) {
                            if (isNOU(_this.timeInterval)) {
                                _this.timeInterval = setInterval(function () {
                                    if (_this.hasContentChanged) {
                                        _this.updateValueOnIdle();
                                        _this.hasContentChanged = false; // Reset after saving
                                    }
                                    else {
                                        clearInterval(_this.timeInterval);
                                        _this.timeInterval = null;
                                    }
                                }, _this.saveInterval);
                            }
                        }
                    }
                    else {
                        // If no changes detected and there's an active interval, clear it
                        if (!_this.autoSaveOnIdle && !isNOU(_this.timeInterval) && !_this.hasContentChanged) {
                            clearInterval(_this.timeInterval);
                            _this.timeInterval = null;
                        }
                    }
                }
            });
            this.mutationObserver.observe(this.inputElement, {
                attributes: true,
                childList: true,
                subtree: true,
                characterData: true,
                attributeOldValue: true
            });
        }
        this.on(events.contentChanged, this.contentChanged, this);
        this.on(events.resizeInitialized, this.updateResizeFlag, this);
        this.on(events.updateTbItemsStatus, this.updateStatus, this);
        this.on(events.cleanupResizeElements, this.cleanupResizeElements, this);
        this.on(events.updateValueOnIdle, this.updateValueOnIdle, this);
        this.on(events.autoResize, this.autoResize, this);
        if (this.iframeSettings.enable) {
            this.onLoadHandler = this.iframeEditableElemLoad.bind(this);
            this.contentModule.getEditPanel().addEventListener('load', this.onLoadHandler, true);
        }
        if (this.readonly && this.enabled) {
            return;
        }
        this.bindEvents();
    };
    RichTextEditor.prototype.restrict = function (e) {
        if (this.maxLength < 0) {
            // return if max length is not set
            return false;
        }
        else {
            var element = this.editorMode === 'Markdown' ? this.contentModule.getText() :
                (this.getText().replace(/(\r\n|\n|\r|\t)/gm, '').replace(/\u200B/g, ''));
            if (!element && this.maxLength !== 0) {
                return false;
            }
            var array = [8, 9, 16, 17, 37, 38, 39, 40, 46, 65];
            var arrayKey = void 0;
            for (var i = 0; i <= array.length - 1; i++) {
                if (e.which === array[i]) {
                    if (e.ctrlKey && e.which === 65) {
                        return false;
                    }
                    else if (e.which !== 65) {
                        arrayKey = array[i];
                        return false;
                    }
                }
            }
            var elementLength = element.length;
            var selectionLength = this.contentModule.getDocument().getSelection().toString().length;
            if (selectionLength > 0) {
                elementLength = element.length - selectionLength;
            }
            if ((elementLength >= this.maxLength && this.maxLength !== -1) && e.which !== arrayKey) {
                e.preventDefault();
                return true;
            }
            return false;
        }
    };
    RichTextEditor.prototype.beforeInputHandler = function (e) {
        if (this.maxLength >= 0) {
            var element = this.editorMode === 'Markdown' ? this.contentModule.getText() :
                (this.getText().replace(/(\r\n|\n|\r|\t)/gm, '').replace(/\u200B/g, ''));
            if (e.data && element.length >= this.maxLength && !this.isSpecialInputType(e)) {
                e.preventDefault();
            }
        }
    };
    RichTextEditor.prototype.isSpecialInputType = function (e) {
        var allowedKeys = [8, 16, 17, 37, 38, 39, 40, 46, 65];
        if (e.inputType) {
            return (e.inputType.indexOf('delete') !== -1 ||
                e.inputType.indexOf('backward') !== -1 ||
                e.inputType === 'insertLineBreak');
        }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return allowedKeys.indexOf(e.which) !== -1;
    };
    RichTextEditor.prototype.dragEnterHandler = function (e) {
        this.notify(EVENTS.dragEnter, e);
        this.formatter.editorManager.observer.notify(EVENTS.dragEnter, e);
    };
    RichTextEditor.prototype.dragOverHandler = function (e) {
        this.notify(EVENTS.dragOver, e);
        this.formatter.editorManager.observer.notify(EVENTS.dragOver, e);
    };
    RichTextEditor.prototype.dropHandler = function (e) {
        var _this = this;
        if (e instanceof DragEvent && e.dataTransfer.types[0] !== 'Files') {
            if (this.formatter.getUndoRedoStack().length === 0 && !this.isSelectionInRTE()) {
                this.formatter.saveData();
            }
            setTimeout(function () {
                _this.formatter.saveData();
                _this.formatter.enableUndo(_this);
            }, 0);
        }
        this.notify(EVENTS.dropEvent, e);
        this.formatter.editorManager.observer.notify(EVENTS.dropEvent, e);
    };
    RichTextEditor.prototype.bindEvents = function () {
        this.keyboardModule = new KeyboardEvents(this.inputElement, {
            keyAction: this.keyDown.bind(this), keyConfigs: __assign({}, this.formatter.keyConfig, this.keyConfig), eventName: 'keydown'
        });
        if (this.userAgentData && this.userAgentData.getPlatform() === 'Android') {
            EventHandler.add(this.inputElement, 'beforeinput', this.beforeInputHandler, this);
        }
        var formElement = closest(this.valueContainer, 'form');
        if (formElement) {
            EventHandler.add(formElement, 'reset', this.resetHandler, this);
        }
        EventHandler.add(this.inputElement, 'keyup', this.keyUp, this);
        EventHandler.add(this.inputElement, 'copy', this.clipBoardHandler, this);
        EventHandler.add(this.inputElement, 'cut', this.clipBoardHandler, this);
        EventHandler.add(this.inputElement, 'paste', this.onPaste, this);
        EventHandler.add(this.inputElement, 'content-changed', this.contentChanged, this);
        this.mouseDownDebListener = debounce(this.mouseUp, 30);
        EventHandler.add(this.inputElement, Browser.touchEndEvent, this.mouseDownDebListener, this);
        EventHandler.add(this.inputElement, Browser.touchStartEvent, this.mouseDownHandler, this);
        EventHandler.add(this.inputElement, 'input', this.inputHandler, this);
        this.wireContextEvent();
        this.formatter.editorManager.observer.on(CONSTANT.KEY_DOWN_HANDLER, this.editorKeyDown, this);
        this.element.ownerDocument.defaultView.addEventListener('resize', this.onResizeHandler, true);
        if (this.iframeSettings.enable) {
            EventHandler.add(this.inputElement, 'focusin', this.focusHandler, this);
            EventHandler.add(this.inputElement, 'focusout', this.blurHandler, this);
            EventHandler.add(this.inputElement.ownerDocument, 'scroll', this.contentScrollHandler, this);
            EventHandler.add(this.inputElement.ownerDocument, Browser.touchStartEvent, this.onIframeMouseDown, this);
            EventHandler.add(this.contentModule.getPanel(), 'load', this.iframeLoadHandler, this);
            EventHandler.add(this.inputElement.ownerDocument, 'dragenter', this.dragEnterHandler, this);
            EventHandler.add(this.inputElement.ownerDocument, 'dragover', this.dragOverHandler, this);
            EventHandler.add(this.inputElement.ownerDocument, 'drop', this.dropHandler, this);
        }
        else {
            EventHandler.add(this.inputElement, 'dragenter', this.dragEnterHandler, this);
            EventHandler.add(this.inputElement, 'dragover', this.dragOverHandler, this);
            EventHandler.add(this.inputElement, 'drop', this.dropHandler, this);
        }
        this.wireScrollElementsEvents();
        // Handle selectionchange to update selection state
        EventHandler.add(this.inputElement.ownerDocument, 'selectionchange', this.selectionChangeHandler, this);
        // Handle mouseup (document-wide to capture outside RTE release)
        EventHandler.add(this.inputElement.ownerDocument, 'mouseup', this.mouseUpHandlerForSelection, this);
    };
    RichTextEditor.prototype.onIframeMouseDown = function (e) {
        this.isBlur = false;
        this.currentTarget = e.target;
        this.notify(events.iframeMouseDown, e);
        this.removeHrFocus(e);
        this.handleChecklistDocumentClick(e, this.currentTarget);
    };
    RichTextEditor.prototype.inputHandler = function () {
        this.autoResize();
        var isPlceHolderEnabled = this.placeHolderWrapper && this.placeHolderWrapper.classList.contains('e-placeholder-enabled');
        var hasText = this.inputElement.textContent.length > 0;
        var hasMediaElements = this.inputElement.querySelector('img, video, audio, table') !== null;
        var hasContent = hasText || hasMediaElements;
        if ((isPlceHolderEnabled && hasContent) || (!isPlceHolderEnabled && !hasContent)) {
            this.setPlaceHolder();
        }
    };
    RichTextEditor.prototype.editorKeyDown = function (e) {
        switch (e.event.action) {
            case 'tab':
                if (this.iframeSettings.enable) {
                    this.isBlur = true;
                }
                break;
            case 'print':
                e.event.preventDefault();
                this.print();
                break;
        }
        if (e.callBack) {
            if (e.event.action === 'delete') {
                e.callBack({
                    requestType: e.event.action,
                    editorMode: 'HTML',
                    event: e.event
                });
            }
            else if (!(this.enableClipboardCleanup && !isNOU(this.clipBoardCleanupModule))) {
                if (e.event.action === 'copy' || e.event.action === 'cut') {
                    e.callBack({
                        requestType: e.event.action,
                        editorMode: 'HTML',
                        event: e.event
                    });
                }
            }
        }
    };
    RichTextEditor.prototype.unWireEvents = function () {
        this.element.removeEventListener('focusin', this.onFocusHandler, true);
        this.onFocusHandler = null;
        this.element.removeEventListener('focusout', this.onBlurHandler, true);
        this.onBlurHandler = null;
        if (this.mutationObserver) {
            this.mutationObserver.disconnect();
            this.mutationObserver = null;
        }
        this.off(events.contentChanged, this.contentChanged);
        this.off(events.resizeInitialized, this.updateResizeFlag);
        this.off(events.updateTbItemsStatus, this.updateStatus);
        this.off(events.cleanupResizeElements, this.cleanupResizeElements);
        this.off(events.updateValueOnIdle, this.updateValueOnIdle);
        this.off(events.autoResize, this.autoResize);
        if (this.iframeSettings.enable) {
            this.contentModule.getEditPanel().removeEventListener('load', this.onLoadHandler, true);
            this.onLoadHandler = null;
        }
        if (this.readonly && this.enabled) {
            return;
        }
        this.unbindEvents();
    };
    RichTextEditor.prototype.unbindEvents = function () {
        if (this.keyboardModule && !this.keyboardModule.isDestroyed) {
            this.keyboardModule.destroy();
            this.keyboardModule = null;
        }
        var formElement = closest(this.valueContainer, 'form');
        if (formElement) {
            EventHandler.remove(formElement, 'reset', this.resetHandler);
        }
        EventHandler.remove(this.inputElement, 'keyup', this.keyUp);
        EventHandler.remove(this.inputElement, 'copy', this.clipBoardHandler);
        EventHandler.remove(this.inputElement, 'cut', this.clipBoardHandler);
        EventHandler.remove(this.inputElement, 'paste', this.onPaste);
        EventHandler.remove(this.inputElement, 'content-changed', this.contentChanged);
        EventHandler.remove(this.inputElement, Browser.touchEndEvent, this.mouseDownDebListener);
        this.mouseDownDebListener = null;
        EventHandler.remove(this.inputElement, Browser.touchStartEvent, this.mouseDownHandler);
        EventHandler.remove(this.inputElement, 'input', this.inputHandler);
        EventHandler.remove(document, 'mousedown', this.onDocumentClick);
        this.unWireContextEvent();
        if (this.formatter) {
            this.formatter.editorManager.observer.off(CONSTANT.KEY_DOWN_HANDLER, this.editorKeyDown);
        }
        this.element.ownerDocument.defaultView.removeEventListener('resize', this.onResizeHandler, true);
        this.onResizeHandler = null;
        if (this.iframeSettings.enable) {
            EventHandler.remove(this.inputElement, 'focusin', this.focusHandler);
            EventHandler.remove(this.inputElement, 'focusout', this.blurHandler);
            EventHandler.remove(this.inputElement.ownerDocument, 'scroll', this.contentScrollHandler);
            EventHandler.remove(this.inputElement.ownerDocument, Browser.touchStartEvent, this.onIframeMouseDown);
            EventHandler.remove(this.contentModule.getPanel(), 'load', this.iframeLoadHandler);
            EventHandler.remove(this.inputElement.ownerDocument, 'dragenter', this.dragEnterHandler);
            EventHandler.remove(this.inputElement.ownerDocument, 'dragover', this.dragOverHandler);
            EventHandler.remove(this.inputElement.ownerDocument, 'drop', this.dropHandler);
        }
        if (!this.iframeSettings.enable) {
            EventHandler.remove(this.inputElement, 'dragenter', this.dragEnterHandler);
            EventHandler.remove(this.inputElement, 'dragover', this.dragOverHandler);
            EventHandler.remove(this.inputElement, 'drop', this.dropHandler);
        }
        if (this.userAgentData && this.userAgentData.getPlatform() === 'Android') {
            EventHandler.remove(this.inputElement, 'beforeinput', this.beforeInputHandler);
        }
        this.unWireScrollElementsEvents();
        EventHandler.remove(this.inputElement.ownerDocument, 'selectionchange', this.selectionChangeHandler);
        EventHandler.remove(this.inputElement.ownerDocument, 'mouseup', this.mouseUpHandlerForSelection);
    };
    /**
     *
     * @param {FocusEvent} e - The focus event.
     * @returns {string} Returns the current focus either `editArea` or `toolbar` or `textArea` or `sourceCode` or `outside` of the RichTextEditor.
     * @hidden
     */
    RichTextEditor.prototype.getCurrentFocus = function (e) {
        if (e.target === this.inputElement && document.activeElement === this.inputElement) {
            return 'editArea';
        }
        else if (e.target === this.getToolbarElement() || (!isNOU(e.relatedTarget) && closest(e.relatedTarget, '.e-rte-toolbar') === this.getToolbarElement())) {
            return 'toolbar';
        }
        else if (e.target === this.valueContainer && document.activeElement === this.valueContainer) {
            return 'textArea';
        }
        else if (!isNOU(e.target) && e.target.classList.contains(classes.CLS_RTE_SOURCE_CODE_TXTAREA)
            && document.activeElement === e.target) {
            return 'sourceCode';
        }
        return 'outside';
    };
    /**
     * @returns {void}
     * @hidden
     */
    RichTextEditor.prototype.resetToolbarTabIndex = function () {
        if (this.getToolbarElement()) {
            var toolbarItem = this.getToolbarElement().querySelectorAll('input,select,button,a,[tabindex]');
            for (var i = 0; i < toolbarItem.length; i++) {
                if ((!toolbarItem[i].classList.contains('e-rte-dropdown-btn') &&
                    !toolbarItem[i].classList.contains('e-insert-table-btn')) &&
                    (!toolbarItem[i].hasAttribute('tabindex') ||
                        toolbarItem[i].getAttribute('tabindex') !== '-1')) {
                    toolbarItem[i].setAttribute('tabindex', '-1');
                }
            }
        }
    };
    RichTextEditor.prototype.getRenderedQuickToolbarElem = function () {
        if (!isNOU(this.quickToolbarModule)) {
            var quickToolbars = this.quickToolbarModule.getQuickToolbarInstance();
            for (var i = 0; i < quickToolbars.length; i++) {
                if (quickToolbars[i] && quickToolbars[i].isRendered) {
                    return quickToolbars[i].element;
                }
            }
        }
        return null;
    };
    RichTextEditor.prototype.iframeLoadHandler = function () {
        this.autoResize();
    };
    RichTextEditor.prototype.iframeEditableElemLoad = function () {
        this.autoResize();
    };
    /**
     * Clears the undo and redo stacks and resets the undo and redo toolbar status to disable the buttons.
     *
     * @returns {void}
     * @public
     */
    RichTextEditor.prototype.clearUndoRedo = function () {
        if (!isNullOrUndefined(this.formatter)) {
            this.formatter.clearUndoRedoStack();
            this.formatter.enableUndo(this);
        }
    };
    RichTextEditor.prototype.removeHrFocus = function (e) {
        if (e.target && this.inputElement.querySelector('hr.e-rte-hr-focus')) {
            var hr = this.inputElement.querySelector('hr.e-rte-hr-focus');
            hr.classList.remove('e-rte-hr-focus');
            if (hr.classList.length === 0) {
                hr.removeAttribute('class');
            }
        }
    };
    /**
     * Utility to check if selection is within RTE
     *
     * @private
     * @returns {boolean} `true` if the selection is within the RTE; otherwise, `false`.
     */
    RichTextEditor.prototype.isSelectionInRTE = function () {
        var selection = this.contentModule.getDocument().getSelection();
        if (selection.rangeCount > 0) {
            var range = selection.getRangeAt(0);
            if (range && (this.inputElement.contains(range.startContainer) &&
                this.inputElement.contains(range.endContainer))) {
                return true;
            }
        }
        return false;
    };
    // EventHandler for selectionchange event
    RichTextEditor.prototype.selectionChangeHandler = function (event) {
        if (this.isSelectionInRTE() && !this.isSelectionCollapsed() && this.isSelectionStartInRTE) {
            this.isSelecting = true;
        }
        if (this.isSelectionInRTE() && !this.isSelectionCollapsed()) {
            this.updateUndoRedoStack(event, true);
        }
    };
    // Checks the selection is within RTE
    RichTextEditor.prototype.isMouseUpOutOfRTE = function (event) {
        var isTargetDocument = event.target && (event.target.nodeName === 'HTML' || event.target.nodeName === '#document');
        var isTargetNotRteElements = !(event.target && event.target.nodeName !== '#text' &&
            event.target.nodeName !== '#document' && event.target.nodeName !== 'HTML' &&
            (event.target.closest('.e-rte-elements') || event.target.closest('.e-rte-toolbar')));
        if (isTargetDocument || (!this.inputElement.contains(event.target) && isTargetNotRteElements)) {
            return true;
        }
        return false;
    };
    // EventHandler for mouseup event
    RichTextEditor.prototype.mouseUpHandlerForSelection = function (event) {
        if (this.isSelecting && this.isMouseUpOutOfRTE(event)) {
            this.endSelection(event);
        }
        this.isSelectionStartInRTE = false;
    };
    // End selection and trigger onTextSelection
    RichTextEditor.prototype.endSelection = function (e) {
        this.handleSelectionChange(e);
        this.isSelecting = false;
    };
    // Checks range is collapsed or not
    RichTextEditor.prototype.isSelectionCollapsed = function () {
        var selection = this.contentModule.getDocument().getSelection();
        var range = selection && selection.rangeCount !== 0 && selection.getRangeAt(0);
        return (range.startContainer === range.endContainer &&
            range.startOffset === range.endOffset);
    };
    // Handles selection changes and updates toolbar and quick toolbar based on user interaction
    RichTextEditor.prototype.handleSelectionChange = function (e) {
        // If selection was made and mouseup occurred (even outside the RTE), trigger quick toolbars
        if (this.inlineMode.enable === true) {
            this.notify(events.selectionChangeMouseUp, { args: e });
        }
        // Determine if quick toolbar should be rendered based on settings and event type
        var shouldRenderQuickToolbar = (!this.inlineMode.enable && this.quickToolbarSettings && (this.quickToolbarSettings.text || (this.quickToolbarSettings.link && e.type === 'mouseup')));
        // Render quick toolbar and notify selectionChangeMouseUp for quicktoolbar functionalities
        if (shouldRenderQuickToolbar) {
            this.notify(events.renderQuickToolbar, { args: e });
            this.notify(events.selectionChangeMouseUp, { args: e });
        }
        // Update the toolbar to reflect current selection state
        if (!(this.quickToolbarModule && this.quickToolbarModule.linkQTBar && this.quickToolbarModule.linkQTBar.element && this.quickToolbarModule.linkQTBar.element.classList.contains('e-popup-open'))) {
            this.notify(events.toolbarRefresh, { args: e });
        }
        this.triggerSelectionChanged();
    };
    /**
     * Utility to check if all then contents are selected within RTE
     *
     * @private
     * @hidden
     * @returns {boolean} `true` if the selection is within the RTE; otherwise, `false`.
     */
    RichTextEditor.prototype.isEntireRTEContentSelected = function () {
        var range = this.contentModule.getDocument().getSelection().getRangeAt(0);
        var div = document.createElement('div');
        div.appendChild(range.cloneContents());
        var selectedHTML = div.innerHTML;
        return (selectedHTML === this.inputElement.innerHTML || (range.commonAncestorContainer === this.inputElement &&
            selectedHTML === this.inputElement.textContent.trim()));
    };
    /**
     * Returns the collection of the Prompt and response data of the AI Assistant.
     *
     * This can be used to retrieve the conversation history between the user and the AI Assistant.
     *
     * @returns {PromptModel[]} An array of PromptModel objects containing the prompt and response history.
     * @public
     *
     * @example
     * // Get the complete history of prompts and responses
     * const promptHistory = editor.getAIPromptHistory();
     *
     * // Display the last conversation
     * if (promptHistory.length > 0) {
     *   const lastConversation = promptHistory[promptHistory.length - 1];
     *   console.log("Last prompt:", lastConversation.prompt);
     *   console.log("Last response:", lastConversation.response);
     * }
     */
    RichTextEditor.prototype.getAIPromptHistory = function () {
        return this.aiAssistantModule.getPromptHistory();
    };
    /**
     * Executes the specified prompt in the AI Assistant.
     *
     * This method sends the provided text as a prompt to the AI Assistant for processing and response.
     *
     * @param {string} prompt - The prompt text to be executed. It must be a non-empty string.
     *
     * @returns {void}
     * @public
     *
     * @example
     * // Execute a simple prompt
     * editor.executeAIPrompt("Review the selected text");
     *
     */
    RichTextEditor.prototype.executeAIPrompt = function (prompt) {
        this.aiAssistantModule.executePrompt(prompt);
    };
    /**
     * Adds a response to the last prompt or appends a new prompt data in the AI Assistant.
     *
     * > The `outputResponse` text should be in `.md` format and will be converted to `.html`.
     *
     * @param {string | Object} outputResponse - The response to be added. Can be:
     *  - A string representing the response text to be added to the last prompt
     *  - An object containing both prompt and response data to be appended or updated
     *
     * @param {boolean} isFinalUpdate - Indicates whether this response is the final one, which will hide the stop response button.
     *                                  Set to true when the complete response has been received.
     *
     * @returns {void}
     * @public
     *
     * @example
     * // Add a simple text response to the last prompt
     * editor.addAIPromptResponse("This is the AI response");
     *
     * // Add a final response (will hide the stop button)
     * editor.addAIPromptResponse("Here is the complete answer", true);
     *
     * // Add a new prompt and response together
     * editor.addAIPromptResponse({
     *   prompt: "How do I format a table?",
     *   response: "To format a table, follow these steps..."
     * });
     */
    RichTextEditor.prototype.addAIPromptResponse = function (outputResponse, isFinalUpdate) {
        this.aiAssistantModule.addPromptResponse(outputResponse, isFinalUpdate);
    };
    /**
     * Shows the AI Assistant Query Popup.
     *
     * This method displays the popup interface for interacting with the AI Assistant,
     * allowing users to enter prompts and view responses.
     *
     * @returns {void}
     * @public
     *
     * @example
     * // Display the AI Assistant popup
     * editor.showAIAssistantPopup();
     *
     * // Create a button that shows the AI Assistant popup
     * document.getElementById('aiButton').addEventListener('click', () => {
     *   editor.showAIAssistantPopup();
     * });
     */
    RichTextEditor.prototype.showAIAssistantPopup = function () {
        this.aiAssistantModule.showQueryPopup();
    };
    /**
     * Hides the AI Assistant Query Popup.
     *
     * This method programmatically closes the AI Assistant popup interface. Useful when
     * handling custom actions via Editor toolbar buttons or when the interaction is complete.
     *
     * @returns {void}
     * @public
     *
     * @example
     * // Close the AI Assistant popup after processing a request
     * editor.executePrompt("Format this paragraph");
     * editor.hideAIAssistantPopup();
     *
     * // Create a custom close button
     * document.getElementById('closeAiButton').addEventListener('click', () => {
     *   editor.hideAIAssistantPopup();
     * });
     */
    RichTextEditor.prototype.hideAIAssistantPopup = function () {
        this.aiAssistantModule.hideAIQueryPopup();
    };
    /**
     * Clears all prompt and response data from the AI Assistant's history stack.
     *
     * This method removes the entire conversation history between the user and the AI Assistant,
     * resetting all stored prompts and responses.
     *
     * @returns {void} No return value.
     * @public
     *
     * @example
     * // Retrieve the current history before clearing
     * const promptHistory = editor.getAIPromptHistory();
     *
     * // Post the history to a database and then clear it
     * editor.clearAIPromptHistory();
     */
    RichTextEditor.prototype.clearAIPromptHistory = function () {
        this.aiAssistantModule.clearAIPromptHistory();
    };
    __decorate([
        Complex({}, ToolbarSettings)
    ], RichTextEditor.prototype, "toolbarSettings", void 0);
    __decorate([
        Complex({ enable: false, items: ['Paragraph', 'Heading 1', 'Heading 2', 'Heading 3', 'Heading 4', 'OrderedList', 'UnorderedList', 'CodeBlock', 'Blockquote'], popupWidth: '300px', popupHeight: '320px' }, SlashMenuSettings)
    ], RichTextEditor.prototype, "slashMenuSettings", void 0);
    __decorate([
        Complex({ commands: DEFAULT_AI_COMMANDS, popupWidth: '600px', popupMaxHeight: '400px', placeholder: 'Ask AI to rewrite or generate content.', headerToolbarSettings: ['AIcommands', 'Close'], promptToolbarSettings: ['Edit', 'Copy'], responseToolbarSettings: ['Regenerate', 'Copy', '|', 'Insert'], prompts: [], suggestions: [], bannerTemplate: '', maxPromptHistory: 20 }, AIAssistantSettings)
    ], RichTextEditor.prototype, "aiAssistantSettings", void 0);
    __decorate([
        Complex({}, QuickToolbarSettings)
    ], RichTextEditor.prototype, "quickToolbarSettings", void 0);
    __decorate([
        Property(true)
    ], RichTextEditor.prototype, "enableClipboardCleanup", void 0);
    __decorate([
        Complex({}, PasteCleanupSettings)
    ], RichTextEditor.prototype, "pasteCleanupSettings", void 0);
    __decorate([
        Complex({}, FormatPainterSettings)
    ], RichTextEditor.prototype, "formatPainterSettings", void 0);
    __decorate([
        Complex({}, EmojiSettings)
    ], RichTextEditor.prototype, "emojiPickerSettings", void 0);
    __decorate([
        Complex({}, IFrameSettings)
    ], RichTextEditor.prototype, "iframeSettings", void 0);
    __decorate([
        Complex({}, ImageSettings)
    ], RichTextEditor.prototype, "insertImageSettings", void 0);
    __decorate([
        Complex({}, ImportWord)
    ], RichTextEditor.prototype, "importWord", void 0);
    __decorate([
        Complex({}, ExportWord)
    ], RichTextEditor.prototype, "exportWord", void 0);
    __decorate([
        Complex({}, ExportPdf)
    ], RichTextEditor.prototype, "exportPdf", void 0);
    __decorate([
        Complex({}, AudioSettings)
    ], RichTextEditor.prototype, "insertAudioSettings", void 0);
    __decorate([
        Complex({}, VideoSettings)
    ], RichTextEditor.prototype, "insertVideoSettings", void 0);
    __decorate([
        Complex({}, TableSettings)
    ], RichTextEditor.prototype, "tableSettings", void 0);
    __decorate([
        Property(0)
    ], RichTextEditor.prototype, "floatingToolbarOffset", void 0);
    __decorate([
        Complex({}, InlineMode)
    ], RichTextEditor.prototype, "inlineMode", void 0);
    __decorate([
        Complex({}, FileManagerSettings)
    ], RichTextEditor.prototype, "fileManagerSettings", void 0);
    __decorate([
        Property('100%')
    ], RichTextEditor.prototype, "width", void 0);
    __decorate([
        Property(false)
    ], RichTextEditor.prototype, "enablePersistence", void 0);
    __decorate([
        Property(true)
    ], RichTextEditor.prototype, "showTooltip", void 0);
    __decorate([
        Property(false)
    ], RichTextEditor.prototype, "enableResize", void 0);
    __decorate([
        Property({})
    ], RichTextEditor.prototype, "htmlAttributes", void 0);
    __decorate([
        Property(null)
    ], RichTextEditor.prototype, "placeholder", void 0);
    __decorate([
        Property(false)
    ], RichTextEditor.prototype, "autoSaveOnIdle", void 0);
    __decorate([
        Property(false)
    ], RichTextEditor.prototype, "readonly", void 0);
    __decorate([
        Property(true)
    ], RichTextEditor.prototype, "enabled", void 0);
    __decorate([
        Property(true)
    ], RichTextEditor.prototype, "enableHtmlSanitizer", void 0);
    __decorate([
        Property(false)
    ], RichTextEditor.prototype, "enableHtmlEncode", void 0);
    __decorate([
        Property(false)
    ], RichTextEditor.prototype, "enableXhtml", void 0);
    __decorate([
        Property(true)
    ], RichTextEditor.prototype, "enableMarkdownAutoFormat", void 0);
    __decorate([
        Property('auto')
    ], RichTextEditor.prototype, "height", void 0);
    __decorate([
        Property(null)
    ], RichTextEditor.prototype, "cssClass", void 0);
    __decorate([
        Property(null)
    ], RichTextEditor.prototype, "value", void 0);
    __decorate([
        Property('P')
    ], RichTextEditor.prototype, "enterKey", void 0);
    __decorate([
        Property('BR')
    ], RichTextEditor.prototype, "shiftEnterKey", void 0);
    __decorate([
        Property(30)
    ], RichTextEditor.prototype, "undoRedoSteps", void 0);
    __decorate([
        Property(300)
    ], RichTextEditor.prototype, "undoRedoTimer", void 0);
    __decorate([
        Property('HTML')
    ], RichTextEditor.prototype, "editorMode", void 0);
    __decorate([
        Property(null)
    ], RichTextEditor.prototype, "keyConfig", void 0);
    __decorate([
        Property(false)
    ], RichTextEditor.prototype, "showCharCount", void 0);
    __decorate([
        Property(false)
    ], RichTextEditor.prototype, "enableTabKey", void 0);
    __decorate([
        Property(false)
    ], RichTextEditor.prototype, "enableAutoUrl", void 0);
    __decorate([
        Property(-1)
    ], RichTextEditor.prototype, "maxLength", void 0);
    __decorate([
        Complex({}, Format)
    ], RichTextEditor.prototype, "format", void 0);
    __decorate([
        Complex({}, CodeBlockSettings)
    ], RichTextEditor.prototype, "codeBlockSettings", void 0);
    __decorate([
        Complex({}, NumberFormatList)
    ], RichTextEditor.prototype, "numberFormatList", void 0);
    __decorate([
        Complex({}, BulletFormatList)
    ], RichTextEditor.prototype, "bulletFormatList", void 0);
    __decorate([
        Complex({}, FontFamily)
    ], RichTextEditor.prototype, "fontFamily", void 0);
    __decorate([
        Complex({}, FontSize)
    ], RichTextEditor.prototype, "fontSize", void 0);
    __decorate([
        Complex({}, LineHeight)
    ], RichTextEditor.prototype, "lineHeight", void 0);
    __decorate([
        Complex({}, FontColor)
    ], RichTextEditor.prototype, "fontColor", void 0);
    __decorate([
        Complex({}, BackgroundColor)
    ], RichTextEditor.prototype, "backgroundColor", void 0);
    __decorate([
        Property(null)
    ], RichTextEditor.prototype, "valueTemplate", void 0);
    __decorate([
        Property(10000)
    ], RichTextEditor.prototype, "saveInterval", void 0);
    __decorate([
        Event()
    ], RichTextEditor.prototype, "actionBegin", void 0);
    __decorate([
        Event()
    ], RichTextEditor.prototype, "actionComplete", void 0);
    __decorate([
        Event()
    ], RichTextEditor.prototype, "beforeClipboardWrite", void 0);
    __decorate([
        Event()
    ], RichTextEditor.prototype, "beforeDialogOpen", void 0);
    __decorate([
        Event()
    ], RichTextEditor.prototype, "dialogOpen", void 0);
    __decorate([
        Event()
    ], RichTextEditor.prototype, "beforeDialogClose", void 0);
    __decorate([
        Event()
    ], RichTextEditor.prototype, "dialogClose", void 0);
    __decorate([
        Event()
    ], RichTextEditor.prototype, "beforeQuickToolbarOpen", void 0);
    __decorate([
        Event()
    ], RichTextEditor.prototype, "quickToolbarOpen", void 0);
    __decorate([
        Event()
    ], RichTextEditor.prototype, "quickToolbarClose", void 0);
    __decorate([
        Event()
    ], RichTextEditor.prototype, "toolbarStatusUpdate", void 0);
    __decorate([
        Event()
    ], RichTextEditor.prototype, "updatedToolbarStatus", void 0);
    __decorate([
        Event()
    ], RichTextEditor.prototype, "imageSelected", void 0);
    __decorate([
        Event()
    ], RichTextEditor.prototype, "beforeImageUpload", void 0);
    __decorate([
        Event()
    ], RichTextEditor.prototype, "imageUploading", void 0);
    __decorate([
        Event()
    ], RichTextEditor.prototype, "imageUploadSuccess", void 0);
    __decorate([
        Event()
    ], RichTextEditor.prototype, "imageUploadFailed", void 0);
    __decorate([
        Event()
    ], RichTextEditor.prototype, "imageRemoving", void 0);
    __decorate([
        Event()
    ], RichTextEditor.prototype, "afterImageDelete", void 0);
    __decorate([
        Event()
    ], RichTextEditor.prototype, "fileSelected", void 0);
    __decorate([
        Event()
    ], RichTextEditor.prototype, "beforeFileUpload", void 0);
    __decorate([
        Event()
    ], RichTextEditor.prototype, "fileUploading", void 0);
    __decorate([
        Event()
    ], RichTextEditor.prototype, "fileUploadSuccess", void 0);
    __decorate([
        Event()
    ], RichTextEditor.prototype, "fileUploadFailed", void 0);
    __decorate([
        Event()
    ], RichTextEditor.prototype, "fileRemoving", void 0);
    __decorate([
        Event()
    ], RichTextEditor.prototype, "afterMediaDelete", void 0);
    __decorate([
        Event()
    ], RichTextEditor.prototype, "created", void 0);
    __decorate([
        Event()
    ], RichTextEditor.prototype, "destroyed", void 0);
    __decorate([
        Event()
    ], RichTextEditor.prototype, "beforeSanitizeHtml", void 0);
    __decorate([
        Event()
    ], RichTextEditor.prototype, "blur", void 0);
    __decorate([
        Event()
    ], RichTextEditor.prototype, "toolbarClick", void 0);
    __decorate([
        Event()
    ], RichTextEditor.prototype, "focus", void 0);
    __decorate([
        Event()
    ], RichTextEditor.prototype, "change", void 0);
    __decorate([
        Event()
    ], RichTextEditor.prototype, "resizing", void 0);
    __decorate([
        Event()
    ], RichTextEditor.prototype, "resizeStart", void 0);
    __decorate([
        Event()
    ], RichTextEditor.prototype, "resizeStop", void 0);
    __decorate([
        Event()
    ], RichTextEditor.prototype, "beforePasteCleanup", void 0);
    __decorate([
        Event()
    ], RichTextEditor.prototype, "afterPasteCleanup", void 0);
    __decorate([
        Event()
    ], RichTextEditor.prototype, "beforeImageDrop", void 0);
    __decorate([
        Event()
    ], RichTextEditor.prototype, "beforeMediaDrop", void 0);
    __decorate([
        Property(null)
    ], RichTextEditor.prototype, "formatter", void 0);
    __decorate([
        Event()
    ], RichTextEditor.prototype, "slashMenuItemSelect", void 0);
    __decorate([
        Event()
    ], RichTextEditor.prototype, "selectionChanged", void 0);
    __decorate([
        Event()
    ], RichTextEditor.prototype, "aiAssistantToolbarClick", void 0);
    __decorate([
        Event()
    ], RichTextEditor.prototype, "aiAssistantPromptRequest", void 0);
    __decorate([
        Event()
    ], RichTextEditor.prototype, "aiAssistantStopRespondingClick", void 0);
    __decorate([
        Event()
    ], RichTextEditor.prototype, "beforePopupOpen", void 0);
    __decorate([
        Event()
    ], RichTextEditor.prototype, "beforePopupClose", void 0);
    __decorate([
        Event()
    ], RichTextEditor.prototype, "wordImporting", void 0);
    __decorate([
        Event()
    ], RichTextEditor.prototype, "documentExporting", void 0);
    __decorate([
        Property(false)
    ], RichTextEditor.prototype, "enableWebMcp", void 0);
    __decorate([
        Event()
    ], RichTextEditor.prototype, "beforeWebMcpToolExecute", void 0);
    __decorate([
        Complex({}, RichTextEditorWebMcpSettings)
    ], RichTextEditor.prototype, "webMcpSettings", void 0);
    RichTextEditor = __decorate([
        NotifyPropertyChanges
    ], RichTextEditor);
    return RichTextEditor;
}(Component));
export { RichTextEditor };
